import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0566ac6f = () => interopDefault(import('../../../pages/404.vue' /* webpackChunkName: "pages/404" */))
const _1cc376e4 = () => interopDefault(import('../../../pages/partners/_partner.vue' /* webpackChunkName: "" */))
const _31473e5a = () => interopDefault(import('../../../pages/promotions/_promotion.vue' /* webpackChunkName: "" */))
const _5dff56cc = () => interopDefault(import('../../../pages/offers/_offer.vue' /* webpackChunkName: "" */))
const _155d4192 = () => interopDefault(import('../../../pages/about-us.vue' /* webpackChunkName: "pages/about-us" */))
const _308556ae = () => interopDefault(import('../../../pages/affiliates/_affiliate.vue' /* webpackChunkName: "" */))
const _4a6046be = () => interopDefault(import('../../../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _478639f0 = () => interopDefault(import('../../../pages/charities/index.vue' /* webpackChunkName: "pages/charities/index" */))
const _07283ab6 = () => interopDefault(import('../../../pages/guidance-notes.vue' /* webpackChunkName: "pages/guidance-notes" */))
const _314988d4 = () => interopDefault(import('../../../pages/how-it-works.vue' /* webpackChunkName: "pages/how-it-works" */))
const _d4191536 = () => interopDefault(import('../../../pages/legal-advice.vue' /* webpackChunkName: "pages/legal-advice" */))
const _403e09d3 = () => interopDefault(import('../../../pages/legal-advice-by-safewill-legal-terms.vue' /* webpackChunkName: "pages/legal-advice-by-safewill-legal-terms" */))
const _6a230349 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _70f68f7a = () => interopDefault(import('../../../pages/power-of-attorney.vue' /* webpackChunkName: "pages/power-of-attorney" */))
const _8da1b706 = () => interopDefault(import('../../../pages/pricing.vue' /* webpackChunkName: "pages/pricing" */))
const _94281182 = () => interopDefault(import('../../../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _cec90a44 = () => interopDefault(import('../../../pages/safewill-legal-terms.vue' /* webpackChunkName: "pages/safewill-legal-terms" */))
const _5fdf0899 = () => interopDefault(import('../../../pages/security.vue' /* webpackChunkName: "pages/security" */))
const _6437bc28 = () => interopDefault(import('../../../pages/sitemap.vue' /* webpackChunkName: "pages/sitemap" */))
const _1420c17e = () => interopDefault(import('../../../pages/terms.vue' /* webpackChunkName: "pages/terms" */))
const _3a30dca9 = () => interopDefault(import('../../../pages/vault.vue' /* webpackChunkName: "pages/vault" */))
const _0fd1b84b = () => interopDefault(import('../../../pages/welcome-back.vue' /* webpackChunkName: "pages/welcome-back" */))
const _315885d8 = () => interopDefault(import('../../../pages/wills.vue' /* webpackChunkName: "pages/wills" */))
const _0178987e = () => interopDefault(import('../../../pages/blog/guides/index.vue' /* webpackChunkName: "pages/blog/guides/index" */))
const _28bc8c82 = () => interopDefault(import('../../../pages/blog/posts/index.vue' /* webpackChunkName: "pages/blog/posts/index" */))
const _3a79894e = () => interopDefault(import('../../../pages/charities/directory/index.vue' /* webpackChunkName: "pages/charities/directory/index" */))
const _2705eb3a = () => interopDefault(import('../../../pages/blog/posts/_slug.vue' /* webpackChunkName: "" */))
const _164acafa = () => interopDefault(import('../../../pages/blog/author/_id.vue' /* webpackChunkName: "pages/blog/author/_id" */))
const _007c1194 = () => interopDefault(import('../../../pages/blog/guides/_slug.vue' /* webpackChunkName: "pages/blog/guides/_slug" */))
const _39cbb7fe = () => interopDefault(import('../../../pages/invites/_code.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _0566ac6f,
    name: "404___au"
  }, {
    path: "/96five",
    component: _1cc376e4,
    name: "96five___au"
  }, {
    path: "/99-offer",
    component: _31473e5a,
    name: "99-offer___au"
  }, {
    path: "/9saver",
    component: _5dff56cc,
    name: "9saver___au"
  }, {
    path: "/about-us",
    component: _155d4192,
    name: "about-us___au"
  }, {
    path: "/accf",
    component: _1cc376e4,
    name: "accf___au"
  }, {
    path: "/acon",
    component: _1cc376e4,
    name: "acon___au"
  }, {
    path: "/acrf",
    component: _1cc376e4,
    name: "acrf___au"
  }, {
    path: "/actionaidaus",
    component: _1cc376e4,
    name: "actionaidaus___au"
  }, {
    path: "/adelaidefringe",
    component: _1cc376e4,
    name: "adelaidefringe___au"
  }, {
    path: "/aeiou",
    component: _1cc376e4,
    name: "aeiou___au"
  }, {
    path: "/afes-123",
    component: _1cc376e4,
    name: "afes-123___au"
  }, {
    path: "/alzheimersaus",
    component: _1cc376e4,
    name: "alzheimersaus___au"
  }, {
    path: "/alzheimerseasternbay",
    component: _1cc376e4,
    name: "alzheimerseasternbay___au"
  }, {
    path: "/alzheimersgisborne",
    component: _1cc376e4,
    name: "alzheimersgisborne___au"
  }, {
    path: "/alzheimersmanawatu",
    component: _1cc376e4,
    name: "alzheimersmanawatu___au"
  }, {
    path: "/alzheimersmarlborough",
    component: _1cc376e4,
    name: "alzheimersmarlborough___au"
  }, {
    path: "/alzheimersnelson",
    component: _1cc376e4,
    name: "alzheimersnelson___au"
  }, {
    path: "/alzheimersnorthland",
    component: _1cc376e4,
    name: "alzheimersnorthland___au"
  }, {
    path: "/alzheimersnz",
    component: _1cc376e4,
    name: "alzheimersnz___au"
  }, {
    path: "/alzheimersotago",
    component: _1cc376e4,
    name: "alzheimersotago___au"
  }, {
    path: "/alzheimerssouthcanterbury",
    component: _1cc376e4,
    name: "alzheimerssouthcanterbury___au"
  }, {
    path: "/alzheimerssouthland",
    component: _1cc376e4,
    name: "alzheimerssouthland___au"
  }, {
    path: "/alzheimerstaranaki",
    component: _1cc376e4,
    name: "alzheimerstaranaki___au"
  }, {
    path: "/alzheimerstauranga",
    component: _1cc376e4,
    name: "alzheimerstauranga___au"
  }, {
    path: "/amnesty",
    component: _1cc376e4,
    name: "amnesty___au"
  }, {
    path: "/anglicarewa",
    component: _1cc376e4,
    name: "anglicarewa___au"
  }, {
    path: "/anzacfoundation",
    component: _1cc376e4,
    name: "anzacfoundation___au"
  }, {
    path: "/anzup",
    component: _1cc376e4,
    name: "anzup___au"
  }, {
    path: "/arrcs",
    component: _1cc376e4,
    name: "arrcs___au"
  }, {
    path: "/arthritisnz",
    component: _1cc376e4,
    name: "arthritisnz___au"
  }, {
    path: "/arthritissa",
    component: _1cc376e4,
    name: "arthritissa___au"
  }, {
    path: "/aspect",
    component: _1cc376e4,
    name: "aspect___au"
  }, {
    path: "/aswairarapa",
    component: _1cc376e4,
    name: "aswairarapa___au"
  }, {
    path: "/aswhanganui",
    component: _1cc376e4,
    name: "aswhanganui___au"
  }, {
    path: "/aurora",
    component: _1cc376e4,
    name: "aurora___au"
  }, {
    path: "/aus-example",
    component: _31473e5a,
    name: "aus-example___au"
  }, {
    path: "/auschildhoodf",
    component: _1cc376e4,
    name: "auschildhoodf___au"
  }, {
    path: "/auspost-123",
    component: _5dff56cc,
    name: "auspost-123___au"
  }, {
    path: "/aussieark",
    component: _1cc376e4,
    name: "aussieark___au"
  }, {
    path: "/austinhealth",
    component: _1cc376e4,
    name: "austinhealth___au"
  }, {
    path: "/austinhealthstaff",
    component: _1cc376e4,
    name: "austinhealthstaff___au"
  }, {
    path: "/australianseniors",
    component: _308556ae,
    name: "australianseniors___au"
  }, {
    path: "/autismnz",
    component: _1cc376e4,
    name: "autismnz___au"
  }, {
    path: "/aware-test",
    component: _308556ae,
    name: "aware-test___au"
  }, {
    path: "/awaresuper",
    component: _308556ae,
    name: "awaresuper___au"
  }, {
    path: "/awaresuper",
    component: _308556ae,
    name: "awaresuper___au"
  }, {
    path: "/awlnsw",
    component: _1cc376e4,
    name: "awlnsw___au"
  }, {
    path: "/bangarra",
    component: _1cc376e4,
    name: "bangarra___au"
  }, {
    path: "/baptistmissionaustralia",
    component: _1cc376e4,
    name: "baptistmissionaustralia___au"
  }, {
    path: "/barnardos",
    component: _1cc376e4,
    name: "barnardos___au"
  }, {
    path: "/barrierreef",
    component: _1cc376e4,
    name: "barrierreef___au"
  }, {
    path: "/bbwh",
    component: _1cc376e4,
    name: "bbwh___au"
  }, {
    path: "/bcrc-wa",
    component: _1cc376e4,
    name: "bcrc-wa___au"
  }, {
    path: "/bearsofhope",
    component: _1cc376e4,
    name: "bearsofhope___au"
  }, {
    path: "/bedfordgroup",
    component: _1cc376e4,
    name: "bedfordgroup___au"
  }, {
    path: "/blackfriday",
    component: _31473e5a,
    name: "blackfriday___au"
  }, {
    path: "/blindlowvisionnz",
    component: _1cc376e4,
    name: "blindlowvisionnz___au"
  }, {
    path: "/blog",
    component: _4a6046be,
    name: "blog___au"
  }, {
    path: "/bluecare",
    component: _1cc376e4,
    name: "bluecare___au"
  }, {
    path: "/blueknot",
    component: _1cc376e4,
    name: "blueknot___au"
  }, {
    path: "/bmf",
    component: _1cc376e4,
    name: "bmf___au"
  }, {
    path: "/bnsw",
    component: _1cc376e4,
    name: "bnsw___au"
  }, {
    path: "/bnsw",
    component: _1cc376e4,
    name: "bnsw___au"
  }, {
    path: "/bobbrown",
    component: _1cc376e4,
    name: "bobbrown___au"
  }, {
    path: "/bravehearts",
    component: _1cc376e4,
    name: "bravehearts___au"
  }, {
    path: "/breastcanceraus",
    component: _1cc376e4,
    name: "breastcanceraus___au"
  }, {
    path: "/browncardigan",
    component: _31473e5a,
    name: "browncardigan___au"
  }, {
    path: "/bsa",
    component: _1cc376e4,
    name: "bsa___au"
  }, {
    path: "/bsl",
    component: _1cc376e4,
    name: "bsl___au"
  }, {
    path: "/buderim",
    component: _1cc376e4,
    name: "buderim___au"
  }, {
    path: "/burnettfoundation",
    component: _1cc376e4,
    name: "burnettfoundation___au"
  }, {
    path: "/bushheritageaustralia",
    component: _1cc376e4,
    name: "bushheritageaustralia___au"
  }, {
    path: "/bwc",
    component: _1cc376e4,
    name: "bwc___au"
  }, {
    path: "/bze",
    component: _1cc376e4,
    name: "bze___au"
  }, {
    path: "/campquality",
    component: _1cc376e4,
    name: "campquality___au"
  }, {
    path: "/campqualityvolunteers",
    component: _1cc376e4,
    name: "campqualityvolunteers___au"
  }, {
    path: "/cancercouncilact",
    component: _1cc376e4,
    name: "cancercouncilact___au"
  }, {
    path: "/cancercouncilnsw",
    component: _1cc376e4,
    name: "cancercouncilnsw___au"
  }, {
    path: "/cancercouncilnswstaff",
    component: _1cc376e4,
    name: "cancercouncilnswstaff___au"
  }, {
    path: "/cancercouncilwa",
    component: _1cc376e4,
    name: "cancercouncilwa___au"
  }, {
    path: "/cancersa",
    component: _1cc376e4,
    name: "cancersa___au"
  }, {
    path: "/cancersocietysouthern",
    component: _1cc376e4,
    name: "cancersocietysouthern___au"
  }, {
    path: "/cancertas",
    component: _1cc376e4,
    name: "cancertas___au"
  }, {
    path: "/cancervic",
    component: _1cc376e4,
    name: "cancervic___au"
  }, {
    path: "/candokids",
    component: _1cc376e4,
    name: "candokids___au"
  }, {
    path: "/canteenaotearoa",
    component: _1cc376e4,
    name: "canteenaotearoa___au"
  }, {
    path: "/cantoo",
    component: _1cc376e4,
    name: "cantoo___au"
  }, {
    path: "/cap",
    component: _1cc376e4,
    name: "cap___au"
  }, {
    path: "/care",
    component: _1cc376e4,
    name: "care___au"
  }, {
    path: "/caringfamilies",
    component: _1cc376e4,
    name: "caringfamilies___au"
  }, {
    path: "/caritas",
    component: _1cc376e4,
    name: "caritas___au"
  }, {
    path: "/cathaven",
    component: _1cc376e4,
    name: "cathaven___au"
  }, {
    path: "/catherinehouse",
    component: _1cc376e4,
    name: "catherinehouse___au"
  }, {
    path: "/catholiccarevic",
    component: _1cc376e4,
    name: "catholiccarevic___au"
  }, {
    path: "/catholicmission",
    component: _1cc376e4,
    name: "catholicmission___au"
  }, {
    path: "/cbmnz",
    component: _1cc376e4,
    name: "cbmnz___au"
  }, {
    path: "/cbrt",
    component: _1cc376e4,
    name: "cbrt___au"
  }, {
    path: "/ccf",
    component: _1cc376e4,
    name: "ccf___au"
  }, {
    path: "/cerebralpalsy",
    component: _1cc376e4,
    name: "cerebralpalsy___au"
  }, {
    path: "/charities",
    component: _478639f0,
    name: "charities___au"
  }, {
    path: "/charlessturt",
    component: _1cc376e4,
    name: "charlessturt___au"
  }, {
    path: "/childfundnz",
    component: _1cc376e4,
    name: "childfundnz___au"
  }, {
    path: "/childhoodcancer",
    component: _1cc376e4,
    name: "childhoodcancer___au"
  }, {
    path: "/citymission",
    component: _1cc376e4,
    name: "citymission___au"
  }, {
    path: "/cnp",
    component: _1cc376e4,
    name: "cnp___au"
  }, {
    path: "/col",
    component: _1cc376e4,
    name: "col___au"
  }, {
    path: "/cpl",
    component: _1cc376e4,
    name: "cpl___au"
  }, {
    path: "/csw",
    component: _1cc376e4,
    name: "csw___au"
  }, {
    path: "/cultureislife",
    component: _1cc376e4,
    name: "cultureislife___au"
  }, {
    path: "/cysticfibrosiswa",
    component: _1cc376e4,
    name: "cysticfibrosiswa___au"
  }, {
    path: "/deafchildrenaus",
    component: _1cc376e4,
    name: "deafchildrenaus___au"
  }, {
    path: "/deakin",
    component: _1cc376e4,
    name: "deakin___au"
  }, {
    path: "/deakin100",
    component: _1cc376e4,
    name: "deakin100___au"
  }, {
    path: "/dfn",
    component: _1cc376e4,
    name: "dfn___au"
  }, {
    path: "/diabetesaus",
    component: _1cc376e4,
    name: "diabetesaus___au"
  }, {
    path: "/diabetesvic",
    component: _1cc376e4,
    name: "diabetesvic___au"
  }, {
    path: "/dsr-123",
    component: _1cc376e4,
    name: "dsr-123___au"
  }, {
    path: "/edgarsmission-123",
    component: _1cc376e4,
    name: "edgarsmission-123___au"
  }, {
    path: "/emanuel",
    component: _1cc376e4,
    name: "emanuel___au"
  }, {
    path: "/endeavourfoundation-123",
    component: _1cc376e4,
    name: "endeavourfoundation-123___au"
  }, {
    path: "/environmentvictoria",
    component: _1cc376e4,
    name: "environmentvictoria___au"
  }, {
    path: "/eofy-24",
    component: _31473e5a,
    name: "eofy-24___au"
  }, {
    path: "/eofy-nz",
    component: _31473e5a,
    name: "eofy-nz___au"
  }, {
    path: "/epc",
    component: _1cc376e4,
    name: "epc___au"
  }, {
    path: "/epc50",
    component: _1cc376e4,
    name: "epc50___au"
  }, {
    path: "/epilepsyactionaus",
    component: _1cc376e4,
    name: "epilepsyactionaus___au"
  }, {
    path: "/epilepsyfoundation",
    component: _1cc376e4,
    name: "epilepsyfoundation___au"
  }, {
    path: "/epilepsyqld",
    component: _1cc376e4,
    name: "epilepsyqld___au"
  }, {
    path: "/equalityaus",
    component: _1cc376e4,
    name: "equalityaus___au"
  }, {
    path: "/ffv",
    component: _1cc376e4,
    name: "ffv___au"
  }, {
    path: "/fiftyup",
    component: _5dff56cc,
    name: "fiftyup___au"
  }, {
    path: "/fightmnd",
    component: _1cc376e4,
    name: "fightmnd___au"
  }, {
    path: "/fightparkinsons",
    component: _1cc376e4,
    name: "fightparkinsons___au"
  }, {
    path: "/fredhollows",
    component: _1cc376e4,
    name: "fredhollows___au"
  }, {
    path: "/fredhollowsnz",
    component: _1cc376e4,
    name: "fredhollowsnz___au"
  }, {
    path: "/fullstop",
    component: _1cc376e4,
    name: "fullstop___au"
  }, {
    path: "/garvan",
    component: _1cc376e4,
    name: "garvan___au"
  }, {
    path: "/gaws",
    component: _1cc376e4,
    name: "gaws___au"
  }, {
    path: "/get-my-will",
    component: _308556ae,
    name: "get-my-will___au"
  }, {
    path: "/girlguidesaus",
    component: _1cc376e4,
    name: "girlguidesaus___au"
  }, {
    path: "/globalinteraction",
    component: _1cc376e4,
    name: "globalinteraction___au"
  }, {
    path: "/greenpeace",
    component: _1cc376e4,
    name: "greenpeace___au"
  }, {
    path: "/greenpeaceaotearoa",
    component: _1cc376e4,
    name: "greenpeaceaotearoa___au"
  }, {
    path: "/growaustralia",
    component: _1cc376e4,
    name: "growaustralia___au"
  }, {
    path: "/gs",
    component: _31473e5a,
    name: "gs___au"
  }, {
    path: "/guidance-notes",
    component: _07283ab6,
    name: "guidance-notes___au"
  }, {
    path: "/guidedogs",
    component: _1cc376e4,
    name: "guidedogs___au"
  }, {
    path: "/guidedogsqld",
    component: _1cc376e4,
    name: "guidedogsqld___au"
  }, {
    path: "/guidedogssant",
    component: _1cc376e4,
    name: "guidedogssant___au"
  }, {
    path: "/guidedogstas",
    component: _1cc376e4,
    name: "guidedogstas___au"
  }, {
    path: "/guidedogsvic",
    component: _1cc376e4,
    name: "guidedogsvic___au"
  }, {
    path: "/guidedogswa",
    component: _1cc376e4,
    name: "guidedogswa___au"
  }, {
    path: "/habitat",
    component: _1cc376e4,
    name: "habitat___au"
  }, {
    path: "/harryperkinsinstitute",
    component: _1cc376e4,
    name: "harryperkinsinstitute___au"
  }, {
    path: "/harvest",
    component: _308556ae,
    name: "harvest___au"
  }, {
    path: "/hatohonestjohn",
    component: _1cc376e4,
    name: "hatohonestjohn___au"
  }, {
    path: "/heartfoundation",
    component: _1cc376e4,
    name: "heartfoundation___au"
  }, {
    path: "/heartkids",
    component: _1cc376e4,
    name: "heartkids___au"
  }, {
    path: "/hopemedia",
    component: _1cc376e4,
    name: "hopemedia___au"
  }, {
    path: "/how-it-works",
    component: _314988d4,
    name: "how-it-works___au"
  }, {
    path: "/hri",
    component: _1cc376e4,
    name: "hri___au"
  }, {
    path: "/hroz",
    component: _1cc376e4,
    name: "hroz___au"
  }, {
    path: "/hudson",
    component: _1cc376e4,
    name: "hudson___au"
  }, {
    path: "/hudsonstaff",
    component: _1cc376e4,
    name: "hudsonstaff___au"
  }, {
    path: "/hutchins",
    component: _1cc376e4,
    name: "hutchins___au"
  }, {
    path: "/huttstcentre",
    component: _1cc376e4,
    name: "huttstcentre___au"
  }, {
    path: "/ihcnz",
    component: _1cc376e4,
    name: "ihcnz___au"
  }, {
    path: "/ilf",
    component: _1cc376e4,
    name: "ilf___au"
  }, {
    path: "/infantshome",
    component: _1cc376e4,
    name: "infantshome___au"
  }, {
    path: "/integrity",
    component: _1cc376e4,
    name: "integrity___au"
  }, {
    path: "/invocare-123",
    component: _1cc376e4,
    name: "invocare-123___au"
  }, {
    path: "/iwc",
    component: _1cc376e4,
    name: "iwc___au"
  }, {
    path: "/iwc-supporters",
    component: _1cc376e4,
    name: "iwc-supporters___au"
  }, {
    path: "/jnf",
    component: _1cc376e4,
    name: "jnf___au"
  }, {
    path: "/kanyana",
    component: _1cc376e4,
    name: "kanyana___au"
  }, {
    path: "/kcrt",
    component: _1cc376e4,
    name: "kcrt___au"
  }, {
    path: "/kevinheinze",
    component: _1cc376e4,
    name: "kevinheinze___au"
  }, {
    path: "/kidneyhealth",
    component: _1cc376e4,
    name: "kidneyhealth___au"
  }, {
    path: "/kidneykidsnz",
    component: _1cc376e4,
    name: "kidneykidsnz___au"
  }, {
    path: "/kidswithcancer",
    component: _1cc376e4,
    name: "kidswithcancer___au"
  }, {
    path: "/kit",
    component: _308556ae,
    name: "kit___au"
  }, {
    path: "/landsearchandrescue",
    component: _1cc376e4,
    name: "landsearchandrescue___au"
  }, {
    path: "/lawpath-123",
    component: _5dff56cc,
    name: "lawpath-123___au"
  }, {
    path: "/legacy",
    component: _1cc376e4,
    name: "legacy___au"
  }, {
    path: "/legacybrisbane",
    component: _1cc376e4,
    name: "legacybrisbane___au"
  }, {
    path: "/legal-advice",
    component: _d4191536,
    name: "legal-advice___au"
  }, {
    path: "/legal-advice-by-safewill-legal-terms",
    component: _403e09d3,
    name: "legal-advice-by-safewill-legal-terms___au"
  }, {
    path: "/leprosymission",
    component: _1cc376e4,
    name: "leprosymission___au"
  }, {
    path: "/leukaemiafoundation",
    component: _1cc376e4,
    name: "leukaemiafoundation___au"
  }, {
    path: "/lifeflightnz",
    component: _1cc376e4,
    name: "lifeflightnz___au"
  }, {
    path: "/lifelineaus",
    component: _1cc376e4,
    name: "lifelineaus___au"
  }, {
    path: "/lifelinedirect",
    component: _1cc376e4,
    name: "lifelinedirect___au"
  }, {
    path: "/lifelineqld",
    component: _1cc376e4,
    name: "lifelineqld___au"
  }, {
    path: "/livinglegends",
    component: _1cc376e4,
    name: "livinglegends___au"
  }, {
    path: "/lmrf",
    component: _1cc376e4,
    name: "lmrf___au"
  }, {
    path: "/lookgoodfeelbetter",
    component: _1cc376e4,
    name: "lookgoodfeelbetter___au"
  }, {
    path: "/lostdogs",
    component: _1cc376e4,
    name: "lostdogs___au"
  }, {
    path: "/lovemercyfoundation",
    component: _1cc376e4,
    name: "lovemercyfoundation___au"
  }, {
    path: "/ltw",
    component: _1cc376e4,
    name: "ltw___au"
  }, {
    path: "/lungfoundation",
    component: _1cc376e4,
    name: "lungfoundation___au"
  }, {
    path: "/manekineko",
    component: _1cc376e4,
    name: "manekineko___au"
  }, {
    path: "/markdown",
    component: _31473e5a,
    name: "markdown___au"
  }, {
    path: "/mater",
    component: _1cc376e4,
    name: "mater___au"
  }, {
    path: "/mcri",
    component: _1cc376e4,
    name: "mcri___au"
  }, {
    path: "/mda",
    component: _1cc376e4,
    name: "mda___au"
  }, {
    path: "/mercermychoice",
    component: _308556ae,
    name: "mercermychoice___au"
  }, {
    path: "/mercersuper",
    component: _308556ae,
    name: "mercersuper___au"
  }, {
    path: "/mercyhealth",
    component: _1cc376e4,
    name: "mercyhealth___au"
  }, {
    path: "/mercyships",
    component: _1cc376e4,
    name: "mercyships___au"
  }, {
    path: "/mercyshipsnz",
    component: _1cc376e4,
    name: "mercyshipsnz___au"
  }, {
    path: "/mhf",
    component: _1cc376e4,
    name: "mhf___au"
  }, {
    path: "/mndnsw",
    component: _1cc376e4,
    name: "mndnsw___au"
  }, {
    path: "/monash",
    component: _1cc376e4,
    name: "monash___au"
  }, {
    path: "/mownsw",
    component: _1cc376e4,
    name: "mownsw___au"
  }, {
    path: "/mowsa",
    component: _1cc376e4,
    name: "mowsa___au"
  }, {
    path: "/msfa",
    component: _1cc376e4,
    name: "msfa___au"
  }, {
    path: "/msfnz",
    component: _1cc376e4,
    name: "msfnz___au"
  }, {
    path: "/mswa",
    component: _1cc376e4,
    name: "mswa___au"
  }, {
    path: "/myroom",
    component: _1cc376e4,
    name: "myroom___au"
  }, {
    path: "/nab-123",
    component: _1cc376e4,
    name: "nab-123___au"
  }, {
    path: "/nationaljockeystrust",
    component: _1cc376e4,
    name: "nationaljockeystrust___au"
  }, {
    path: "/nationaltrustnsw",
    component: _1cc376e4,
    name: "nationaltrustnsw___au"
  }, {
    path: "/nationaltrustwa",
    component: _1cc376e4,
    name: "nationaltrustwa___au"
  }, {
    path: "/nationaltrustwa-members",
    component: _1cc376e4,
    name: "nationaltrustwa-members___au"
  }, {
    path: "/naturefoundation-123",
    component: _1cc376e4,
    name: "naturefoundation-123___au"
  }, {
    path: "/ncf",
    component: _1cc376e4,
    name: "ncf___au"
  }, {
    path: "/neura",
    component: _1cc376e4,
    name: "neura___au"
  }, {
    path: "/newyears",
    component: _31473e5a,
    name: "newyears___au"
  }, {
    path: "/nextsense",
    component: _1cc376e4,
    name: "nextsense___au"
  }, {
    path: "/north",
    component: _1cc376e4,
    name: "north___au"
  }, {
    path: "/nswliberalnm",
    component: _1cc376e4,
    name: "nswliberalnm___au"
  }, {
    path: "/nswpolicelegacy",
    component: _1cc376e4,
    name: "nswpolicelegacy___au"
  }, {
    path: "/nswrfsa",
    component: _1cc376e4,
    name: "nswrfsa___au"
  }, {
    path: "/nz",
    component: _6a230349,
    name: "index___nz"
  }, {
    path: "/olivianewtonjohn",
    component: _1cc376e4,
    name: "olivianewtonjohn___au"
  }, {
    path: "/onebigswitch",
    component: _5dff56cc,
    name: "onebigswitch___au"
  }, {
    path: "/operationsmile",
    component: _1cc376e4,
    name: "operationsmile___au"
  }, {
    path: "/outwardboundnz",
    component: _1cc376e4,
    name: "outwardboundnz___au"
  }, {
    path: "/oxfam",
    component: _1cc376e4,
    name: "oxfam___au"
  }, {
    path: "/pancarefoundation",
    component: _1cc376e4,
    name: "pancarefoundation___au"
  }, {
    path: "/pankind",
    component: _1cc376e4,
    name: "pankind___au"
  }, {
    path: "/paralympicsaus",
    component: _1cc376e4,
    name: "paralympicsaus___au"
  }, {
    path: "/parkinsonsaustralia",
    component: _1cc376e4,
    name: "parkinsonsaustralia___au"
  }, {
    path: "/pchf",
    component: _1cc376e4,
    name: "pchf___au"
  }, {
    path: "/pcycnsw",
    component: _1cc376e4,
    name: "pcycnsw___au"
  }, {
    path: "/petermac",
    component: _1cc376e4,
    name: "petermac___au"
  }, {
    path: "/petsofthehomeless",
    component: _1cc376e4,
    name: "petsofthehomeless___au"
  }, {
    path: "/petwelfare",
    component: _1cc376e4,
    name: "petwelfare___au"
  }, {
    path: "/planinternational",
    component: _1cc376e4,
    name: "planinternational___au"
  }, {
    path: "/power-of-attorney",
    component: _70f68f7a,
    name: "power-of-attorney___au"
  }, {
    path: "/pricing",
    component: _8da1b706,
    name: "pricing___au"
  }, {
    path: "/privacy",
    component: _94281182,
    name: "privacy___au"
  }, {
    path: "/rawcs",
    component: _1cc376e4,
    name: "rawcs___au"
  }, {
    path: "/rchfoundation",
    component: _1cc376e4,
    name: "rchfoundation___au"
  }, {
    path: "/realinsurance",
    component: _308556ae,
    name: "realinsurance___au"
  }, {
    path: "/redcross",
    component: _1cc376e4,
    name: "redcross___au"
  }, {
    path: "/rhemamedia",
    component: _1cc376e4,
    name: "rhemamedia___au"
  }, {
    path: "/rhhr-123",
    component: _1cc376e4,
    name: "rhhr-123___au"
  }, {
    path: "/rlsswa",
    component: _1cc376e4,
    name: "rlsswa___au"
  }, {
    path: "/rmhc",
    component: _1cc376e4,
    name: "rmhc___au"
  }, {
    path: "/rmhcsydney",
    component: _1cc376e4,
    name: "rmhcsydney___au"
  }, {
    path: "/rotaryfoundation",
    component: _1cc376e4,
    name: "rotaryfoundation___au"
  }, {
    path: "/royalfarwest",
    component: _1cc376e4,
    name: "royalfarwest___au"
  }, {
    path: "/rphresearch",
    component: _1cc376e4,
    name: "rphresearch___au"
  }, {
    path: "/rslaustralia",
    component: _1cc376e4,
    name: "rslaustralia___au"
  }, {
    path: "/rspca",
    component: _1cc376e4,
    name: "rspca___au"
  }, {
    path: "/ruralaid",
    component: _1cc376e4,
    name: "ruralaid___au"
  }, {
    path: "/safe",
    component: _1cc376e4,
    name: "safe___au"
  }, {
    path: "/safesteps",
    component: _1cc376e4,
    name: "safesteps___au"
  }, {
    path: "/safewill-legal-terms",
    component: _cec90a44,
    name: "safewill-legal-terms___au"
  }, {
    path: "/sasy",
    component: _1cc376e4,
    name: "sasy___au"
  }, {
    path: "/savethechildren",
    component: _1cc376e4,
    name: "savethechildren___au"
  }, {
    path: "/security",
    component: _5fdf0899,
    name: "security___au"
  }, {
    path: "/seedmob",
    component: _1cc376e4,
    name: "seedmob___au"
  }, {
    path: "/seeingeyedogs",
    component: _1cc376e4,
    name: "seeingeyedogs___au"
  }, {
    path: "/shine-123",
    component: _5dff56cc,
    name: "shine-123___au"
  }, {
    path: "/shm",
    component: _1cc376e4,
    name: "shm___au"
  }, {
    path: "/sitemap",
    component: _6437bc28,
    name: "sitemap___au"
  }, {
    path: "/slsf",
    component: _1cc376e4,
    name: "slsf___au"
  }, {
    path: "/sonshine",
    component: _1cc376e4,
    name: "sonshine___au"
  }, {
    path: "/sor",
    component: _1cc376e4,
    name: "sor___au"
  }, {
    path: "/spca",
    component: _1cc376e4,
    name: "spca___au"
  }, {
    path: "/ssh",
    component: _1cc376e4,
    name: "ssh___au"
  }, {
    path: "/standrewswmh",
    component: _1cc376e4,
    name: "standrewswmh___au"
  }, {
    path: "/starlight",
    component: _1cc376e4,
    name: "starlight___au"
  }, {
    path: "/stcnz",
    component: _1cc376e4,
    name: "stcnz___au"
  }, {
    path: "/steppingstonehouse",
    component: _1cc376e4,
    name: "steppingstonehouse___au"
  }, {
    path: "/stevewaugh",
    component: _1cc376e4,
    name: "stevewaugh___au"
  }, {
    path: "/stjohnwa",
    component: _1cc376e4,
    name: "stjohnwa___au"
  }, {
    path: "/streamfoundation",
    component: _1cc376e4,
    name: "streamfoundation___au"
  }, {
    path: "/stride",
    component: _1cc376e4,
    name: "stride___au"
  }, {
    path: "/sunsw",
    component: _1cc376e4,
    name: "sunsw___au"
  }, {
    path: "/surflifesavingnz",
    component: _1cc376e4,
    name: "surflifesavingnz___au"
  }, {
    path: "/svcf",
    component: _1cc376e4,
    name: "svcf___au"
  }, {
    path: "/svdpvic",
    component: _1cc376e4,
    name: "svdpvic___au"
  }, {
    path: "/SVDPWA",
    component: _1cc376e4,
    name: "SVDPWA___au"
  }, {
    path: "/svh",
    component: _1cc376e4,
    name: "svh___au"
  }, {
    path: "/swans",
    component: _1cc376e4,
    name: "swans___au"
  }, {
    path: "/swt-123",
    component: _1cc376e4,
    name: "swt-123___au"
  }, {
    path: "/symmetry",
    component: _308556ae,
    name: "symmetry___au"
  }, {
    path: "/tearfundaus",
    component: _1cc376e4,
    name: "tearfundaus___au"
  }, {
    path: "/terms",
    component: _1420c17e,
    name: "terms___au"
  }, {
    path: "/thearthritismovement",
    component: _1cc376e4,
    name: "thearthritismovement___au"
  }, {
    path: "/theconversation",
    component: _1cc376e4,
    name: "theconversation___au"
  }, {
    path: "/theheartfoundation",
    component: _1cc376e4,
    name: "theheartfoundation___au"
  }, {
    path: "/thekids",
    component: _1cc376e4,
    name: "thekids___au"
  }, {
    path: "/thelifeyoucansave",
    component: _1cc376e4,
    name: "thelifeyoucansave___au"
  }, {
    path: "/thelight",
    component: _1cc376e4,
    name: "thelight___au"
  }, {
    path: "/thepyjamafoundation",
    component: _1cc376e4,
    name: "thepyjamafoundation___au"
  }, {
    path: "/thewesleyhospital",
    component: _1cc376e4,
    name: "thewesleyhospital___au"
  }, {
    path: "/thissweetlife",
    component: _31473e5a,
    name: "thissweetlife___au"
  }, {
    path: "/thrfg",
    component: _1cc376e4,
    name: "thrfg___au"
  }, {
    path: "/trmh",
    component: _1cc376e4,
    name: "trmh___au"
  }, {
    path: "/uia-123",
    component: _1cc376e4,
    name: "uia-123___au"
  }, {
    path: "/uni-newcastle",
    component: _1cc376e4,
    name: "uni-newcastle___au"
  }, {
    path: "/unicef",
    component: _1cc376e4,
    name: "unicef___au"
  }, {
    path: "/unicefaotearoa",
    component: _1cc376e4,
    name: "unicefaotearoa___au"
  }, {
    path: "/uniting",
    component: _1cc376e4,
    name: "uniting___au"
  }, {
    path: "/unitingcareqld",
    component: _1cc376e4,
    name: "unitingcareqld___au"
  }, {
    path: "/unsw",
    component: _1cc376e4,
    name: "unsw___au"
  }, {
    path: "/usyd",
    component: _1cc376e4,
    name: "usyd___au"
  }, {
    path: "/varietynswact",
    component: _1cc376e4,
    name: "varietynswact___au"
  }, {
    path: "/varietyvic",
    component: _1cc376e4,
    name: "varietyvic___au"
  }, {
    path: "/varietywa",
    component: _1cc376e4,
    name: "varietywa___au"
  }, {
    path: "/vault",
    component: _3a30dca9,
    name: "vault___au"
  }, {
    path: "/victorchang",
    component: _1cc376e4,
    name: "victorchang___au"
  }, {
    path: "/vinnies-nsw-123",
    component: _1cc376e4,
    name: "vinnies-nsw-123___au"
  }, {
    path: "/vinniesact-surrounds",
    component: _1cc376e4,
    name: "vinniesact-surrounds___au"
  }, {
    path: "/vinniesnsw",
    component: _1cc376e4,
    name: "vinniesnsw___au"
  }, {
    path: "/virginmoneysuper",
    component: _308556ae,
    name: "virginmoneysuper___au"
  }, {
    path: "/vision",
    component: _1cc376e4,
    name: "vision___au"
  }, {
    path: "/visionaus",
    component: _1cc376e4,
    name: "visionaus___au"
  }, {
    path: "/vsanz",
    component: _1cc376e4,
    name: "vsanz___au"
  }, {
    path: "/vu",
    component: _1cc376e4,
    name: "vu___au"
  }, {
    path: "/wap",
    component: _1cc376e4,
    name: "wap___au"
  }, {
    path: "/wapnz",
    component: _1cc376e4,
    name: "wapnz___au"
  }, {
    path: "/wateraid-123",
    component: _1cc376e4,
    name: "wateraid-123___au"
  }, {
    path: "/wehi",
    component: _1cc376e4,
    name: "wehi___au"
  }, {
    path: "/welcome-back",
    component: _0fd1b84b,
    name: "welcome-back___au"
  }, {
    path: "/wemeanwell",
    component: _31473e5a,
    name: "wemeanwell___au"
  }, {
    path: "/wesleymission",
    component: _1cc376e4,
    name: "wesleymission___au"
  }, {
    path: "/wfh",
    component: _1cc376e4,
    name: "wfh___au"
  }, {
    path: "/wheenbee",
    component: _1cc376e4,
    name: "wheenbee___au"
  }, {
    path: "/wilderness",
    component: _1cc376e4,
    name: "wilderness___au"
  }, {
    path: "/wildernessaus",
    component: _1cc376e4,
    name: "wildernessaus___au"
  }, {
    path: "/wildlifevictoria",
    component: _1cc376e4,
    name: "wildlifevictoria___au"
  }, {
    path: "/wills",
    component: _315885d8,
    name: "wills___au"
  }, {
    path: "/wires",
    component: _1cc376e4,
    name: "wires___au"
  }, {
    path: "/wishlist",
    component: _1cc376e4,
    name: "wishlist___au"
  }, {
    path: "/womencan",
    component: _1cc376e4,
    name: "womencan___au"
  }, {
    path: "/worldshare",
    component: _1cc376e4,
    name: "worldshare___au"
  }, {
    path: "/worldvision",
    component: _1cc376e4,
    name: "worldvision___au"
  }, {
    path: "/worldvisionnz",
    component: _1cc376e4,
    name: "worldvisionnz___au"
  }, {
    path: "/write-your-will",
    component: _31473e5a,
    name: "write-your-will___au"
  }, {
    path: "/wwf",
    component: _1cc376e4,
    name: "wwf___au"
  }, {
    path: "/yellowbridgeqld",
    component: _1cc376e4,
    name: "yellowbridgeqld___au"
  }, {
    path: "/yots",
    component: _1cc376e4,
    name: "yots___au"
  }, {
    path: "/youngcare",
    component: _1cc376e4,
    name: "youngcare___au"
  }, {
    path: "/youthfocus",
    component: _1cc376e4,
    name: "youthfocus___au"
  }, {
    path: "/blog/guides",
    component: _0178987e,
    name: "blog-guides___au"
  }, {
    path: "/blog/posts",
    component: _28bc8c82,
    name: "blog-posts___au"
  }, {
    path: "/charities/directory",
    component: _3a79894e,
    name: "charities-directory___au"
  }, {
    path: "/nz/404",
    component: _0566ac6f,
    name: "404___nz"
  }, {
    path: "/nz/96five",
    component: _1cc376e4,
    name: "96five___nz"
  }, {
    path: "/nz/99-offer",
    component: _31473e5a,
    name: "99-offer___nz"
  }, {
    path: "/nz/9saver",
    component: _5dff56cc,
    name: "9saver___nz"
  }, {
    path: "/nz/about-us",
    component: _155d4192,
    name: "about-us___nz"
  }, {
    path: "/nz/accf",
    component: _1cc376e4,
    name: "accf___nz"
  }, {
    path: "/nz/acon",
    component: _1cc376e4,
    name: "acon___nz"
  }, {
    path: "/nz/acrf",
    component: _1cc376e4,
    name: "acrf___nz"
  }, {
    path: "/nz/actionaidaus",
    component: _1cc376e4,
    name: "actionaidaus___nz"
  }, {
    path: "/nz/adelaidefringe",
    component: _1cc376e4,
    name: "adelaidefringe___nz"
  }, {
    path: "/nz/aeiou",
    component: _1cc376e4,
    name: "aeiou___nz"
  }, {
    path: "/nz/afes-123",
    component: _1cc376e4,
    name: "afes-123___nz"
  }, {
    path: "/nz/alzheimersaus",
    component: _1cc376e4,
    name: "alzheimersaus___nz"
  }, {
    path: "/nz/alzheimerseasternbay",
    component: _1cc376e4,
    name: "alzheimerseasternbay___nz"
  }, {
    path: "/nz/alzheimersgisborne",
    component: _1cc376e4,
    name: "alzheimersgisborne___nz"
  }, {
    path: "/nz/alzheimersmanawatu",
    component: _1cc376e4,
    name: "alzheimersmanawatu___nz"
  }, {
    path: "/nz/alzheimersmarlborough",
    component: _1cc376e4,
    name: "alzheimersmarlborough___nz"
  }, {
    path: "/nz/alzheimersnelson",
    component: _1cc376e4,
    name: "alzheimersnelson___nz"
  }, {
    path: "/nz/alzheimersnorthland",
    component: _1cc376e4,
    name: "alzheimersnorthland___nz"
  }, {
    path: "/nz/alzheimersnz",
    component: _1cc376e4,
    name: "alzheimersnz___nz"
  }, {
    path: "/nz/alzheimersotago",
    component: _1cc376e4,
    name: "alzheimersotago___nz"
  }, {
    path: "/nz/alzheimerssouthcanterbury",
    component: _1cc376e4,
    name: "alzheimerssouthcanterbury___nz"
  }, {
    path: "/nz/alzheimerssouthland",
    component: _1cc376e4,
    name: "alzheimerssouthland___nz"
  }, {
    path: "/nz/alzheimerstaranaki",
    component: _1cc376e4,
    name: "alzheimerstaranaki___nz"
  }, {
    path: "/nz/alzheimerstauranga",
    component: _1cc376e4,
    name: "alzheimerstauranga___nz"
  }, {
    path: "/nz/amnesty",
    component: _1cc376e4,
    name: "amnesty___nz"
  }, {
    path: "/nz/anglicarewa",
    component: _1cc376e4,
    name: "anglicarewa___nz"
  }, {
    path: "/nz/anzacfoundation",
    component: _1cc376e4,
    name: "anzacfoundation___nz"
  }, {
    path: "/nz/anzup",
    component: _1cc376e4,
    name: "anzup___nz"
  }, {
    path: "/nz/arrcs",
    component: _1cc376e4,
    name: "arrcs___nz"
  }, {
    path: "/nz/arthritisnz",
    component: _1cc376e4,
    name: "arthritisnz___nz"
  }, {
    path: "/nz/arthritissa",
    component: _1cc376e4,
    name: "arthritissa___nz"
  }, {
    path: "/nz/aspect",
    component: _1cc376e4,
    name: "aspect___nz"
  }, {
    path: "/nz/aswairarapa",
    component: _1cc376e4,
    name: "aswairarapa___nz"
  }, {
    path: "/nz/aswhanganui",
    component: _1cc376e4,
    name: "aswhanganui___nz"
  }, {
    path: "/nz/aurora",
    component: _1cc376e4,
    name: "aurora___nz"
  }, {
    path: "/nz/aus-example",
    component: _31473e5a,
    name: "aus-example___nz"
  }, {
    path: "/nz/auschildhoodf",
    component: _1cc376e4,
    name: "auschildhoodf___nz"
  }, {
    path: "/nz/auspost-123",
    component: _5dff56cc,
    name: "auspost-123___nz"
  }, {
    path: "/nz/aussieark",
    component: _1cc376e4,
    name: "aussieark___nz"
  }, {
    path: "/nz/austinhealth",
    component: _1cc376e4,
    name: "austinhealth___nz"
  }, {
    path: "/nz/austinhealthstaff",
    component: _1cc376e4,
    name: "austinhealthstaff___nz"
  }, {
    path: "/nz/australianseniors",
    component: _308556ae,
    name: "australianseniors___nz"
  }, {
    path: "/nz/autismnz",
    component: _1cc376e4,
    name: "autismnz___nz"
  }, {
    path: "/nz/aware-test",
    component: _308556ae,
    name: "aware-test___nz"
  }, {
    path: "/nz/awaresuper",
    component: _308556ae,
    name: "awaresuper___nz"
  }, {
    path: "/nz/awaresuper",
    component: _308556ae,
    name: "awaresuper___nz"
  }, {
    path: "/nz/awlnsw",
    component: _1cc376e4,
    name: "awlnsw___nz"
  }, {
    path: "/nz/bangarra",
    component: _1cc376e4,
    name: "bangarra___nz"
  }, {
    path: "/nz/baptistmissionaustralia",
    component: _1cc376e4,
    name: "baptistmissionaustralia___nz"
  }, {
    path: "/nz/barnardos",
    component: _1cc376e4,
    name: "barnardos___nz"
  }, {
    path: "/nz/barrierreef",
    component: _1cc376e4,
    name: "barrierreef___nz"
  }, {
    path: "/nz/bbwh",
    component: _1cc376e4,
    name: "bbwh___nz"
  }, {
    path: "/nz/bcrc-wa",
    component: _1cc376e4,
    name: "bcrc-wa___nz"
  }, {
    path: "/nz/bearsofhope",
    component: _1cc376e4,
    name: "bearsofhope___nz"
  }, {
    path: "/nz/bedfordgroup",
    component: _1cc376e4,
    name: "bedfordgroup___nz"
  }, {
    path: "/nz/blackfriday",
    component: _31473e5a,
    name: "blackfriday___nz"
  }, {
    path: "/nz/blindlowvisionnz",
    component: _1cc376e4,
    name: "blindlowvisionnz___nz"
  }, {
    path: "/nz/blog",
    component: _4a6046be,
    name: "blog___nz"
  }, {
    path: "/nz/bluecare",
    component: _1cc376e4,
    name: "bluecare___nz"
  }, {
    path: "/nz/blueknot",
    component: _1cc376e4,
    name: "blueknot___nz"
  }, {
    path: "/nz/bmf",
    component: _1cc376e4,
    name: "bmf___nz"
  }, {
    path: "/nz/bnsw",
    component: _1cc376e4,
    name: "bnsw___nz"
  }, {
    path: "/nz/bnsw",
    component: _1cc376e4,
    name: "bnsw___nz"
  }, {
    path: "/nz/bobbrown",
    component: _1cc376e4,
    name: "bobbrown___nz"
  }, {
    path: "/nz/bravehearts",
    component: _1cc376e4,
    name: "bravehearts___nz"
  }, {
    path: "/nz/breastcanceraus",
    component: _1cc376e4,
    name: "breastcanceraus___nz"
  }, {
    path: "/nz/browncardigan",
    component: _31473e5a,
    name: "browncardigan___nz"
  }, {
    path: "/nz/bsa",
    component: _1cc376e4,
    name: "bsa___nz"
  }, {
    path: "/nz/bsl",
    component: _1cc376e4,
    name: "bsl___nz"
  }, {
    path: "/nz/buderim",
    component: _1cc376e4,
    name: "buderim___nz"
  }, {
    path: "/nz/burnettfoundation",
    component: _1cc376e4,
    name: "burnettfoundation___nz"
  }, {
    path: "/nz/bushheritageaustralia",
    component: _1cc376e4,
    name: "bushheritageaustralia___nz"
  }, {
    path: "/nz/bwc",
    component: _1cc376e4,
    name: "bwc___nz"
  }, {
    path: "/nz/bze",
    component: _1cc376e4,
    name: "bze___nz"
  }, {
    path: "/nz/campquality",
    component: _1cc376e4,
    name: "campquality___nz"
  }, {
    path: "/nz/campqualityvolunteers",
    component: _1cc376e4,
    name: "campqualityvolunteers___nz"
  }, {
    path: "/nz/cancercouncilact",
    component: _1cc376e4,
    name: "cancercouncilact___nz"
  }, {
    path: "/nz/cancercouncilnsw",
    component: _1cc376e4,
    name: "cancercouncilnsw___nz"
  }, {
    path: "/nz/cancercouncilnswstaff",
    component: _1cc376e4,
    name: "cancercouncilnswstaff___nz"
  }, {
    path: "/nz/cancercouncilwa",
    component: _1cc376e4,
    name: "cancercouncilwa___nz"
  }, {
    path: "/nz/cancersa",
    component: _1cc376e4,
    name: "cancersa___nz"
  }, {
    path: "/nz/cancersocietysouthern",
    component: _1cc376e4,
    name: "cancersocietysouthern___nz"
  }, {
    path: "/nz/cancertas",
    component: _1cc376e4,
    name: "cancertas___nz"
  }, {
    path: "/nz/cancervic",
    component: _1cc376e4,
    name: "cancervic___nz"
  }, {
    path: "/nz/candokids",
    component: _1cc376e4,
    name: "candokids___nz"
  }, {
    path: "/nz/canteenaotearoa",
    component: _1cc376e4,
    name: "canteenaotearoa___nz"
  }, {
    path: "/nz/cantoo",
    component: _1cc376e4,
    name: "cantoo___nz"
  }, {
    path: "/nz/cap",
    component: _1cc376e4,
    name: "cap___nz"
  }, {
    path: "/nz/care",
    component: _1cc376e4,
    name: "care___nz"
  }, {
    path: "/nz/caringfamilies",
    component: _1cc376e4,
    name: "caringfamilies___nz"
  }, {
    path: "/nz/caritas",
    component: _1cc376e4,
    name: "caritas___nz"
  }, {
    path: "/nz/cathaven",
    component: _1cc376e4,
    name: "cathaven___nz"
  }, {
    path: "/nz/catherinehouse",
    component: _1cc376e4,
    name: "catherinehouse___nz"
  }, {
    path: "/nz/catholiccarevic",
    component: _1cc376e4,
    name: "catholiccarevic___nz"
  }, {
    path: "/nz/catholicmission",
    component: _1cc376e4,
    name: "catholicmission___nz"
  }, {
    path: "/nz/cbmnz",
    component: _1cc376e4,
    name: "cbmnz___nz"
  }, {
    path: "/nz/cbrt",
    component: _1cc376e4,
    name: "cbrt___nz"
  }, {
    path: "/nz/ccf",
    component: _1cc376e4,
    name: "ccf___nz"
  }, {
    path: "/nz/cerebralpalsy",
    component: _1cc376e4,
    name: "cerebralpalsy___nz"
  }, {
    path: "/nz/charities",
    component: _478639f0,
    name: "charities___nz"
  }, {
    path: "/nz/charlessturt",
    component: _1cc376e4,
    name: "charlessturt___nz"
  }, {
    path: "/nz/childfundnz",
    component: _1cc376e4,
    name: "childfundnz___nz"
  }, {
    path: "/nz/childhoodcancer",
    component: _1cc376e4,
    name: "childhoodcancer___nz"
  }, {
    path: "/nz/citymission",
    component: _1cc376e4,
    name: "citymission___nz"
  }, {
    path: "/nz/cnp",
    component: _1cc376e4,
    name: "cnp___nz"
  }, {
    path: "/nz/col",
    component: _1cc376e4,
    name: "col___nz"
  }, {
    path: "/nz/cpl",
    component: _1cc376e4,
    name: "cpl___nz"
  }, {
    path: "/nz/csw",
    component: _1cc376e4,
    name: "csw___nz"
  }, {
    path: "/nz/cultureislife",
    component: _1cc376e4,
    name: "cultureislife___nz"
  }, {
    path: "/nz/cysticfibrosiswa",
    component: _1cc376e4,
    name: "cysticfibrosiswa___nz"
  }, {
    path: "/nz/deafchildrenaus",
    component: _1cc376e4,
    name: "deafchildrenaus___nz"
  }, {
    path: "/nz/deakin",
    component: _1cc376e4,
    name: "deakin___nz"
  }, {
    path: "/nz/deakin100",
    component: _1cc376e4,
    name: "deakin100___nz"
  }, {
    path: "/nz/dfn",
    component: _1cc376e4,
    name: "dfn___nz"
  }, {
    path: "/nz/diabetesaus",
    component: _1cc376e4,
    name: "diabetesaus___nz"
  }, {
    path: "/nz/diabetesvic",
    component: _1cc376e4,
    name: "diabetesvic___nz"
  }, {
    path: "/nz/dsr-123",
    component: _1cc376e4,
    name: "dsr-123___nz"
  }, {
    path: "/nz/edgarsmission-123",
    component: _1cc376e4,
    name: "edgarsmission-123___nz"
  }, {
    path: "/nz/emanuel",
    component: _1cc376e4,
    name: "emanuel___nz"
  }, {
    path: "/nz/endeavourfoundation-123",
    component: _1cc376e4,
    name: "endeavourfoundation-123___nz"
  }, {
    path: "/nz/environmentvictoria",
    component: _1cc376e4,
    name: "environmentvictoria___nz"
  }, {
    path: "/nz/eofy-24",
    component: _31473e5a,
    name: "eofy-24___nz"
  }, {
    path: "/nz/eofy-nz",
    component: _31473e5a,
    name: "eofy-nz___nz"
  }, {
    path: "/nz/epc",
    component: _1cc376e4,
    name: "epc___nz"
  }, {
    path: "/nz/epc50",
    component: _1cc376e4,
    name: "epc50___nz"
  }, {
    path: "/nz/epilepsyactionaus",
    component: _1cc376e4,
    name: "epilepsyactionaus___nz"
  }, {
    path: "/nz/epilepsyfoundation",
    component: _1cc376e4,
    name: "epilepsyfoundation___nz"
  }, {
    path: "/nz/epilepsyqld",
    component: _1cc376e4,
    name: "epilepsyqld___nz"
  }, {
    path: "/nz/equalityaus",
    component: _1cc376e4,
    name: "equalityaus___nz"
  }, {
    path: "/nz/ffv",
    component: _1cc376e4,
    name: "ffv___nz"
  }, {
    path: "/nz/fiftyup",
    component: _5dff56cc,
    name: "fiftyup___nz"
  }, {
    path: "/nz/fightmnd",
    component: _1cc376e4,
    name: "fightmnd___nz"
  }, {
    path: "/nz/fightparkinsons",
    component: _1cc376e4,
    name: "fightparkinsons___nz"
  }, {
    path: "/nz/fredhollows",
    component: _1cc376e4,
    name: "fredhollows___nz"
  }, {
    path: "/nz/fredhollowsnz",
    component: _1cc376e4,
    name: "fredhollowsnz___nz"
  }, {
    path: "/nz/fullstop",
    component: _1cc376e4,
    name: "fullstop___nz"
  }, {
    path: "/nz/garvan",
    component: _1cc376e4,
    name: "garvan___nz"
  }, {
    path: "/nz/gaws",
    component: _1cc376e4,
    name: "gaws___nz"
  }, {
    path: "/nz/get-my-will",
    component: _308556ae,
    name: "get-my-will___nz"
  }, {
    path: "/nz/girlguidesaus",
    component: _1cc376e4,
    name: "girlguidesaus___nz"
  }, {
    path: "/nz/globalinteraction",
    component: _1cc376e4,
    name: "globalinteraction___nz"
  }, {
    path: "/nz/greenpeace",
    component: _1cc376e4,
    name: "greenpeace___nz"
  }, {
    path: "/nz/greenpeaceaotearoa",
    component: _1cc376e4,
    name: "greenpeaceaotearoa___nz"
  }, {
    path: "/nz/growaustralia",
    component: _1cc376e4,
    name: "growaustralia___nz"
  }, {
    path: "/nz/gs",
    component: _31473e5a,
    name: "gs___nz"
  }, {
    path: "/nz/guidance-notes",
    component: _07283ab6,
    name: "guidance-notes___nz"
  }, {
    path: "/nz/guidedogs",
    component: _1cc376e4,
    name: "guidedogs___nz"
  }, {
    path: "/nz/guidedogsqld",
    component: _1cc376e4,
    name: "guidedogsqld___nz"
  }, {
    path: "/nz/guidedogssant",
    component: _1cc376e4,
    name: "guidedogssant___nz"
  }, {
    path: "/nz/guidedogstas",
    component: _1cc376e4,
    name: "guidedogstas___nz"
  }, {
    path: "/nz/guidedogsvic",
    component: _1cc376e4,
    name: "guidedogsvic___nz"
  }, {
    path: "/nz/guidedogswa",
    component: _1cc376e4,
    name: "guidedogswa___nz"
  }, {
    path: "/nz/habitat",
    component: _1cc376e4,
    name: "habitat___nz"
  }, {
    path: "/nz/harryperkinsinstitute",
    component: _1cc376e4,
    name: "harryperkinsinstitute___nz"
  }, {
    path: "/nz/harvest",
    component: _308556ae,
    name: "harvest___nz"
  }, {
    path: "/nz/hatohonestjohn",
    component: _1cc376e4,
    name: "hatohonestjohn___nz"
  }, {
    path: "/nz/heartfoundation",
    component: _1cc376e4,
    name: "heartfoundation___nz"
  }, {
    path: "/nz/heartkids",
    component: _1cc376e4,
    name: "heartkids___nz"
  }, {
    path: "/nz/hopemedia",
    component: _1cc376e4,
    name: "hopemedia___nz"
  }, {
    path: "/nz/how-it-works",
    component: _314988d4,
    name: "how-it-works___nz"
  }, {
    path: "/nz/hri",
    component: _1cc376e4,
    name: "hri___nz"
  }, {
    path: "/nz/hroz",
    component: _1cc376e4,
    name: "hroz___nz"
  }, {
    path: "/nz/hudson",
    component: _1cc376e4,
    name: "hudson___nz"
  }, {
    path: "/nz/hudsonstaff",
    component: _1cc376e4,
    name: "hudsonstaff___nz"
  }, {
    path: "/nz/hutchins",
    component: _1cc376e4,
    name: "hutchins___nz"
  }, {
    path: "/nz/huttstcentre",
    component: _1cc376e4,
    name: "huttstcentre___nz"
  }, {
    path: "/nz/ihcnz",
    component: _1cc376e4,
    name: "ihcnz___nz"
  }, {
    path: "/nz/ilf",
    component: _1cc376e4,
    name: "ilf___nz"
  }, {
    path: "/nz/infantshome",
    component: _1cc376e4,
    name: "infantshome___nz"
  }, {
    path: "/nz/integrity",
    component: _1cc376e4,
    name: "integrity___nz"
  }, {
    path: "/nz/invocare-123",
    component: _1cc376e4,
    name: "invocare-123___nz"
  }, {
    path: "/nz/iwc",
    component: _1cc376e4,
    name: "iwc___nz"
  }, {
    path: "/nz/iwc-supporters",
    component: _1cc376e4,
    name: "iwc-supporters___nz"
  }, {
    path: "/nz/jnf",
    component: _1cc376e4,
    name: "jnf___nz"
  }, {
    path: "/nz/kanyana",
    component: _1cc376e4,
    name: "kanyana___nz"
  }, {
    path: "/nz/kcrt",
    component: _1cc376e4,
    name: "kcrt___nz"
  }, {
    path: "/nz/kevinheinze",
    component: _1cc376e4,
    name: "kevinheinze___nz"
  }, {
    path: "/nz/kidneyhealth",
    component: _1cc376e4,
    name: "kidneyhealth___nz"
  }, {
    path: "/nz/kidneykidsnz",
    component: _1cc376e4,
    name: "kidneykidsnz___nz"
  }, {
    path: "/nz/kidswithcancer",
    component: _1cc376e4,
    name: "kidswithcancer___nz"
  }, {
    path: "/nz/kit",
    component: _308556ae,
    name: "kit___nz"
  }, {
    path: "/nz/landsearchandrescue",
    component: _1cc376e4,
    name: "landsearchandrescue___nz"
  }, {
    path: "/nz/lawpath-123",
    component: _5dff56cc,
    name: "lawpath-123___nz"
  }, {
    path: "/nz/legacy",
    component: _1cc376e4,
    name: "legacy___nz"
  }, {
    path: "/nz/legacybrisbane",
    component: _1cc376e4,
    name: "legacybrisbane___nz"
  }, {
    path: "/nz/legal-advice",
    component: _d4191536,
    name: "legal-advice___nz"
  }, {
    path: "/nz/legal-advice-by-safewill-legal-terms",
    component: _403e09d3,
    name: "legal-advice-by-safewill-legal-terms___nz"
  }, {
    path: "/nz/leprosymission",
    component: _1cc376e4,
    name: "leprosymission___nz"
  }, {
    path: "/nz/leukaemiafoundation",
    component: _1cc376e4,
    name: "leukaemiafoundation___nz"
  }, {
    path: "/nz/lifeflightnz",
    component: _1cc376e4,
    name: "lifeflightnz___nz"
  }, {
    path: "/nz/lifelineaus",
    component: _1cc376e4,
    name: "lifelineaus___nz"
  }, {
    path: "/nz/lifelinedirect",
    component: _1cc376e4,
    name: "lifelinedirect___nz"
  }, {
    path: "/nz/lifelineqld",
    component: _1cc376e4,
    name: "lifelineqld___nz"
  }, {
    path: "/nz/livinglegends",
    component: _1cc376e4,
    name: "livinglegends___nz"
  }, {
    path: "/nz/lmrf",
    component: _1cc376e4,
    name: "lmrf___nz"
  }, {
    path: "/nz/lookgoodfeelbetter",
    component: _1cc376e4,
    name: "lookgoodfeelbetter___nz"
  }, {
    path: "/nz/lostdogs",
    component: _1cc376e4,
    name: "lostdogs___nz"
  }, {
    path: "/nz/lovemercyfoundation",
    component: _1cc376e4,
    name: "lovemercyfoundation___nz"
  }, {
    path: "/nz/ltw",
    component: _1cc376e4,
    name: "ltw___nz"
  }, {
    path: "/nz/lungfoundation",
    component: _1cc376e4,
    name: "lungfoundation___nz"
  }, {
    path: "/nz/manekineko",
    component: _1cc376e4,
    name: "manekineko___nz"
  }, {
    path: "/nz/markdown",
    component: _31473e5a,
    name: "markdown___nz"
  }, {
    path: "/nz/mater",
    component: _1cc376e4,
    name: "mater___nz"
  }, {
    path: "/nz/mcri",
    component: _1cc376e4,
    name: "mcri___nz"
  }, {
    path: "/nz/mda",
    component: _1cc376e4,
    name: "mda___nz"
  }, {
    path: "/nz/mercermychoice",
    component: _308556ae,
    name: "mercermychoice___nz"
  }, {
    path: "/nz/mercersuper",
    component: _308556ae,
    name: "mercersuper___nz"
  }, {
    path: "/nz/mercyhealth",
    component: _1cc376e4,
    name: "mercyhealth___nz"
  }, {
    path: "/nz/mercyships",
    component: _1cc376e4,
    name: "mercyships___nz"
  }, {
    path: "/nz/mercyshipsnz",
    component: _1cc376e4,
    name: "mercyshipsnz___nz"
  }, {
    path: "/nz/mhf",
    component: _1cc376e4,
    name: "mhf___nz"
  }, {
    path: "/nz/mndnsw",
    component: _1cc376e4,
    name: "mndnsw___nz"
  }, {
    path: "/nz/monash",
    component: _1cc376e4,
    name: "monash___nz"
  }, {
    path: "/nz/mownsw",
    component: _1cc376e4,
    name: "mownsw___nz"
  }, {
    path: "/nz/mowsa",
    component: _1cc376e4,
    name: "mowsa___nz"
  }, {
    path: "/nz/msfa",
    component: _1cc376e4,
    name: "msfa___nz"
  }, {
    path: "/nz/msfnz",
    component: _1cc376e4,
    name: "msfnz___nz"
  }, {
    path: "/nz/mswa",
    component: _1cc376e4,
    name: "mswa___nz"
  }, {
    path: "/nz/myroom",
    component: _1cc376e4,
    name: "myroom___nz"
  }, {
    path: "/nz/nab-123",
    component: _1cc376e4,
    name: "nab-123___nz"
  }, {
    path: "/nz/nationaljockeystrust",
    component: _1cc376e4,
    name: "nationaljockeystrust___nz"
  }, {
    path: "/nz/nationaltrustnsw",
    component: _1cc376e4,
    name: "nationaltrustnsw___nz"
  }, {
    path: "/nz/nationaltrustwa",
    component: _1cc376e4,
    name: "nationaltrustwa___nz"
  }, {
    path: "/nz/nationaltrustwa-members",
    component: _1cc376e4,
    name: "nationaltrustwa-members___nz"
  }, {
    path: "/nz/naturefoundation-123",
    component: _1cc376e4,
    name: "naturefoundation-123___nz"
  }, {
    path: "/nz/ncf",
    component: _1cc376e4,
    name: "ncf___nz"
  }, {
    path: "/nz/neura",
    component: _1cc376e4,
    name: "neura___nz"
  }, {
    path: "/nz/newyears",
    component: _31473e5a,
    name: "newyears___nz"
  }, {
    path: "/nz/nextsense",
    component: _1cc376e4,
    name: "nextsense___nz"
  }, {
    path: "/nz/north",
    component: _1cc376e4,
    name: "north___nz"
  }, {
    path: "/nz/nswliberalnm",
    component: _1cc376e4,
    name: "nswliberalnm___nz"
  }, {
    path: "/nz/nswpolicelegacy",
    component: _1cc376e4,
    name: "nswpolicelegacy___nz"
  }, {
    path: "/nz/nswrfsa",
    component: _1cc376e4,
    name: "nswrfsa___nz"
  }, {
    path: "/nz/olivianewtonjohn",
    component: _1cc376e4,
    name: "olivianewtonjohn___nz"
  }, {
    path: "/nz/onebigswitch",
    component: _5dff56cc,
    name: "onebigswitch___nz"
  }, {
    path: "/nz/operationsmile",
    component: _1cc376e4,
    name: "operationsmile___nz"
  }, {
    path: "/nz/outwardboundnz",
    component: _1cc376e4,
    name: "outwardboundnz___nz"
  }, {
    path: "/nz/oxfam",
    component: _1cc376e4,
    name: "oxfam___nz"
  }, {
    path: "/nz/pancarefoundation",
    component: _1cc376e4,
    name: "pancarefoundation___nz"
  }, {
    path: "/nz/pankind",
    component: _1cc376e4,
    name: "pankind___nz"
  }, {
    path: "/nz/paralympicsaus",
    component: _1cc376e4,
    name: "paralympicsaus___nz"
  }, {
    path: "/nz/parkinsonsaustralia",
    component: _1cc376e4,
    name: "parkinsonsaustralia___nz"
  }, {
    path: "/nz/pchf",
    component: _1cc376e4,
    name: "pchf___nz"
  }, {
    path: "/nz/pcycnsw",
    component: _1cc376e4,
    name: "pcycnsw___nz"
  }, {
    path: "/nz/petermac",
    component: _1cc376e4,
    name: "petermac___nz"
  }, {
    path: "/nz/petsofthehomeless",
    component: _1cc376e4,
    name: "petsofthehomeless___nz"
  }, {
    path: "/nz/petwelfare",
    component: _1cc376e4,
    name: "petwelfare___nz"
  }, {
    path: "/nz/planinternational",
    component: _1cc376e4,
    name: "planinternational___nz"
  }, {
    path: "/nz/power-of-attorney",
    component: _70f68f7a,
    name: "power-of-attorney___nz"
  }, {
    path: "/nz/pricing",
    component: _8da1b706,
    name: "pricing___nz"
  }, {
    path: "/nz/privacy",
    component: _94281182,
    name: "privacy___nz"
  }, {
    path: "/nz/rawcs",
    component: _1cc376e4,
    name: "rawcs___nz"
  }, {
    path: "/nz/rchfoundation",
    component: _1cc376e4,
    name: "rchfoundation___nz"
  }, {
    path: "/nz/realinsurance",
    component: _308556ae,
    name: "realinsurance___nz"
  }, {
    path: "/nz/redcross",
    component: _1cc376e4,
    name: "redcross___nz"
  }, {
    path: "/nz/rhemamedia",
    component: _1cc376e4,
    name: "rhemamedia___nz"
  }, {
    path: "/nz/rhhr-123",
    component: _1cc376e4,
    name: "rhhr-123___nz"
  }, {
    path: "/nz/rlsswa",
    component: _1cc376e4,
    name: "rlsswa___nz"
  }, {
    path: "/nz/rmhc",
    component: _1cc376e4,
    name: "rmhc___nz"
  }, {
    path: "/nz/rmhcsydney",
    component: _1cc376e4,
    name: "rmhcsydney___nz"
  }, {
    path: "/nz/rotaryfoundation",
    component: _1cc376e4,
    name: "rotaryfoundation___nz"
  }, {
    path: "/nz/royalfarwest",
    component: _1cc376e4,
    name: "royalfarwest___nz"
  }, {
    path: "/nz/rphresearch",
    component: _1cc376e4,
    name: "rphresearch___nz"
  }, {
    path: "/nz/rslaustralia",
    component: _1cc376e4,
    name: "rslaustralia___nz"
  }, {
    path: "/nz/rspca",
    component: _1cc376e4,
    name: "rspca___nz"
  }, {
    path: "/nz/ruralaid",
    component: _1cc376e4,
    name: "ruralaid___nz"
  }, {
    path: "/nz/safe",
    component: _1cc376e4,
    name: "safe___nz"
  }, {
    path: "/nz/safesteps",
    component: _1cc376e4,
    name: "safesteps___nz"
  }, {
    path: "/nz/safewill-legal-terms",
    component: _cec90a44,
    name: "safewill-legal-terms___nz"
  }, {
    path: "/nz/sasy",
    component: _1cc376e4,
    name: "sasy___nz"
  }, {
    path: "/nz/savethechildren",
    component: _1cc376e4,
    name: "savethechildren___nz"
  }, {
    path: "/nz/security",
    component: _5fdf0899,
    name: "security___nz"
  }, {
    path: "/nz/seedmob",
    component: _1cc376e4,
    name: "seedmob___nz"
  }, {
    path: "/nz/seeingeyedogs",
    component: _1cc376e4,
    name: "seeingeyedogs___nz"
  }, {
    path: "/nz/shine-123",
    component: _5dff56cc,
    name: "shine-123___nz"
  }, {
    path: "/nz/shm",
    component: _1cc376e4,
    name: "shm___nz"
  }, {
    path: "/nz/sitemap",
    component: _6437bc28,
    name: "sitemap___nz"
  }, {
    path: "/nz/slsf",
    component: _1cc376e4,
    name: "slsf___nz"
  }, {
    path: "/nz/sonshine",
    component: _1cc376e4,
    name: "sonshine___nz"
  }, {
    path: "/nz/sor",
    component: _1cc376e4,
    name: "sor___nz"
  }, {
    path: "/nz/spca",
    component: _1cc376e4,
    name: "spca___nz"
  }, {
    path: "/nz/ssh",
    component: _1cc376e4,
    name: "ssh___nz"
  }, {
    path: "/nz/standrewswmh",
    component: _1cc376e4,
    name: "standrewswmh___nz"
  }, {
    path: "/nz/starlight",
    component: _1cc376e4,
    name: "starlight___nz"
  }, {
    path: "/nz/stcnz",
    component: _1cc376e4,
    name: "stcnz___nz"
  }, {
    path: "/nz/steppingstonehouse",
    component: _1cc376e4,
    name: "steppingstonehouse___nz"
  }, {
    path: "/nz/stevewaugh",
    component: _1cc376e4,
    name: "stevewaugh___nz"
  }, {
    path: "/nz/stjohnwa",
    component: _1cc376e4,
    name: "stjohnwa___nz"
  }, {
    path: "/nz/streamfoundation",
    component: _1cc376e4,
    name: "streamfoundation___nz"
  }, {
    path: "/nz/stride",
    component: _1cc376e4,
    name: "stride___nz"
  }, {
    path: "/nz/sunsw",
    component: _1cc376e4,
    name: "sunsw___nz"
  }, {
    path: "/nz/surflifesavingnz",
    component: _1cc376e4,
    name: "surflifesavingnz___nz"
  }, {
    path: "/nz/svcf",
    component: _1cc376e4,
    name: "svcf___nz"
  }, {
    path: "/nz/svdpvic",
    component: _1cc376e4,
    name: "svdpvic___nz"
  }, {
    path: "/nz/SVDPWA",
    component: _1cc376e4,
    name: "SVDPWA___nz"
  }, {
    path: "/nz/svh",
    component: _1cc376e4,
    name: "svh___nz"
  }, {
    path: "/nz/swans",
    component: _1cc376e4,
    name: "swans___nz"
  }, {
    path: "/nz/swt-123",
    component: _1cc376e4,
    name: "swt-123___nz"
  }, {
    path: "/nz/symmetry",
    component: _308556ae,
    name: "symmetry___nz"
  }, {
    path: "/nz/tearfundaus",
    component: _1cc376e4,
    name: "tearfundaus___nz"
  }, {
    path: "/nz/terms",
    component: _1420c17e,
    name: "terms___nz"
  }, {
    path: "/nz/thearthritismovement",
    component: _1cc376e4,
    name: "thearthritismovement___nz"
  }, {
    path: "/nz/theconversation",
    component: _1cc376e4,
    name: "theconversation___nz"
  }, {
    path: "/nz/theheartfoundation",
    component: _1cc376e4,
    name: "theheartfoundation___nz"
  }, {
    path: "/nz/thekids",
    component: _1cc376e4,
    name: "thekids___nz"
  }, {
    path: "/nz/thelifeyoucansave",
    component: _1cc376e4,
    name: "thelifeyoucansave___nz"
  }, {
    path: "/nz/thelight",
    component: _1cc376e4,
    name: "thelight___nz"
  }, {
    path: "/nz/thepyjamafoundation",
    component: _1cc376e4,
    name: "thepyjamafoundation___nz"
  }, {
    path: "/nz/thewesleyhospital",
    component: _1cc376e4,
    name: "thewesleyhospital___nz"
  }, {
    path: "/nz/thissweetlife",
    component: _31473e5a,
    name: "thissweetlife___nz"
  }, {
    path: "/nz/thrfg",
    component: _1cc376e4,
    name: "thrfg___nz"
  }, {
    path: "/nz/trmh",
    component: _1cc376e4,
    name: "trmh___nz"
  }, {
    path: "/nz/uia-123",
    component: _1cc376e4,
    name: "uia-123___nz"
  }, {
    path: "/nz/uni-newcastle",
    component: _1cc376e4,
    name: "uni-newcastle___nz"
  }, {
    path: "/nz/unicef",
    component: _1cc376e4,
    name: "unicef___nz"
  }, {
    path: "/nz/unicefaotearoa",
    component: _1cc376e4,
    name: "unicefaotearoa___nz"
  }, {
    path: "/nz/uniting",
    component: _1cc376e4,
    name: "uniting___nz"
  }, {
    path: "/nz/unitingcareqld",
    component: _1cc376e4,
    name: "unitingcareqld___nz"
  }, {
    path: "/nz/unsw",
    component: _1cc376e4,
    name: "unsw___nz"
  }, {
    path: "/nz/usyd",
    component: _1cc376e4,
    name: "usyd___nz"
  }, {
    path: "/nz/varietynswact",
    component: _1cc376e4,
    name: "varietynswact___nz"
  }, {
    path: "/nz/varietyvic",
    component: _1cc376e4,
    name: "varietyvic___nz"
  }, {
    path: "/nz/varietywa",
    component: _1cc376e4,
    name: "varietywa___nz"
  }, {
    path: "/nz/vault",
    component: _3a30dca9,
    name: "vault___nz"
  }, {
    path: "/nz/victorchang",
    component: _1cc376e4,
    name: "victorchang___nz"
  }, {
    path: "/nz/vinnies-nsw-123",
    component: _1cc376e4,
    name: "vinnies-nsw-123___nz"
  }, {
    path: "/nz/vinniesact-surrounds",
    component: _1cc376e4,
    name: "vinniesact-surrounds___nz"
  }, {
    path: "/nz/vinniesnsw",
    component: _1cc376e4,
    name: "vinniesnsw___nz"
  }, {
    path: "/nz/virginmoneysuper",
    component: _308556ae,
    name: "virginmoneysuper___nz"
  }, {
    path: "/nz/vision",
    component: _1cc376e4,
    name: "vision___nz"
  }, {
    path: "/nz/visionaus",
    component: _1cc376e4,
    name: "visionaus___nz"
  }, {
    path: "/nz/vsanz",
    component: _1cc376e4,
    name: "vsanz___nz"
  }, {
    path: "/nz/vu",
    component: _1cc376e4,
    name: "vu___nz"
  }, {
    path: "/nz/wap",
    component: _1cc376e4,
    name: "wap___nz"
  }, {
    path: "/nz/wapnz",
    component: _1cc376e4,
    name: "wapnz___nz"
  }, {
    path: "/nz/wateraid-123",
    component: _1cc376e4,
    name: "wateraid-123___nz"
  }, {
    path: "/nz/wehi",
    component: _1cc376e4,
    name: "wehi___nz"
  }, {
    path: "/nz/welcome-back",
    component: _0fd1b84b,
    name: "welcome-back___nz"
  }, {
    path: "/nz/wemeanwell",
    component: _31473e5a,
    name: "wemeanwell___nz"
  }, {
    path: "/nz/wesleymission",
    component: _1cc376e4,
    name: "wesleymission___nz"
  }, {
    path: "/nz/wfh",
    component: _1cc376e4,
    name: "wfh___nz"
  }, {
    path: "/nz/wheenbee",
    component: _1cc376e4,
    name: "wheenbee___nz"
  }, {
    path: "/nz/wilderness",
    component: _1cc376e4,
    name: "wilderness___nz"
  }, {
    path: "/nz/wildernessaus",
    component: _1cc376e4,
    name: "wildernessaus___nz"
  }, {
    path: "/nz/wildlifevictoria",
    component: _1cc376e4,
    name: "wildlifevictoria___nz"
  }, {
    path: "/nz/wills",
    component: _315885d8,
    name: "wills___nz"
  }, {
    path: "/nz/wires",
    component: _1cc376e4,
    name: "wires___nz"
  }, {
    path: "/nz/wishlist",
    component: _1cc376e4,
    name: "wishlist___nz"
  }, {
    path: "/nz/womencan",
    component: _1cc376e4,
    name: "womencan___nz"
  }, {
    path: "/nz/worldshare",
    component: _1cc376e4,
    name: "worldshare___nz"
  }, {
    path: "/nz/worldvision",
    component: _1cc376e4,
    name: "worldvision___nz"
  }, {
    path: "/nz/worldvisionnz",
    component: _1cc376e4,
    name: "worldvisionnz___nz"
  }, {
    path: "/nz/write-your-will",
    component: _31473e5a,
    name: "write-your-will___nz"
  }, {
    path: "/nz/wwf",
    component: _1cc376e4,
    name: "wwf___nz"
  }, {
    path: "/nz/yellowbridgeqld",
    component: _1cc376e4,
    name: "yellowbridgeqld___nz"
  }, {
    path: "/nz/yots",
    component: _1cc376e4,
    name: "yots___nz"
  }, {
    path: "/nz/youngcare",
    component: _1cc376e4,
    name: "youngcare___nz"
  }, {
    path: "/nz/youthfocus",
    component: _1cc376e4,
    name: "youthfocus___nz"
  }, {
    path: "/blog/posts/10-reasons-why-you-need-a-will",
    component: _2705eb3a,
    name: "10-reasons-why-you-need-a-will___au"
  }, {
    path: "/blog/posts/11-reasons-you-should-choose-safewill",
    component: _2705eb3a,
    name: "11-reasons-you-should-choose-safewill___au"
  }, {
    path: "/blog/posts/3-ways-to-save-on-funeral-costs",
    component: _2705eb3a,
    name: "3-ways-to-save-on-funeral-costs___au"
  }, {
    path: "/blog/posts/4-actionable-tips-for-an-eco-friendly-funeral",
    component: _2705eb3a,
    name: "4-actionable-tips-for-an-eco-friendly-funeral___au"
  }, {
    path: "/blog/posts/4-alternative-condolence-gifts-to-flowers",
    component: _2705eb3a,
    name: "4-alternative-condolence-gifts-to-flowers___au"
  }, {
    path: "/blog/posts/5-benefits-of-writing-your-will-young",
    component: _2705eb3a,
    name: "5-benefits-of-writing-your-will-young___au"
  }, {
    path: "/blog/posts/5-common-myths-about-online-wills",
    component: _2705eb3a,
    name: "5-common-myths-about-online-wills___au"
  }, {
    path: "/blog/posts/5-different-cultural-approaches-to-death",
    component: _2705eb3a,
    name: "5-different-cultural-approaches-to-death___au"
  }, {
    path: "/blog/posts/5-distinguishing-benefits-of-digital-vs-traditional-wills",
    component: _2705eb3a,
    name: "5-distinguishing-benefits-of-digital-vs-traditional-wills___au"
  }, {
    path: "/blog/posts/5-life-altering-takeaways-from-the-top-ted-talks-on-death",
    component: _2705eb3a,
    name: "5-life-altering-takeaways-from-the-top-ted-talks-on-death___au"
  }, {
    path: "/blog/posts/5-meaningful-funeral-quotes-about-death",
    component: _2705eb3a,
    name: "5-meaningful-funeral-quotes-about-death___au"
  }, {
    path: "/blog/posts/5-reasons-to-update-your-will",
    component: _2705eb3a,
    name: "5-reasons-to-update-your-will___au"
  }, {
    path: "/blog/posts/5-scientific-rules-for-making-breaking-goals-in-2023",
    component: _2705eb3a,
    name: "5-scientific-rules-for-making-breaking-goals-in-2023___au"
  }, {
    path: "/blog/posts/5-surprising-celebrities-who-died-without-a-will",
    component: _2705eb3a,
    name: "5-surprising-celebrities-who-died-without-a-will___au"
  }, {
    path: "/blog/posts/5-tips-to-safeguard-your-mental-health-against-stress",
    component: _2705eb3a,
    name: "5-tips-to-safeguard-your-mental-health-against-stress___au"
  }, {
    path: "/blog/posts/6-easy-health-hacks-for-a-longer-life",
    component: _2705eb3a,
    name: "6-easy-health-hacks-for-a-longer-life___au"
  }, {
    path: "/blog/posts/6-ways-to-handle-your-estate",
    component: _2705eb3a,
    name: "6-ways-to-handle-your-estate___au"
  }, {
    path: "/blog/posts/a-guide-to-sydneys-cemeteries-in-2022",
    component: _2705eb3a,
    name: "a-guide-to-sydneys-cemeteries-in-2022___au"
  }, {
    path: "/blog/posts/advance-care-directive",
    component: _2705eb3a,
    name: "advance-care-directive___au"
  }, {
    path: "/blog/posts/advanced-healthcare-directives-matter-heres-why",
    component: _2705eb3a,
    name: "advanced-healthcare-directives-matter-heres-why___au"
  }, {
    path: "/blog/posts/another-year-gone-reflecting-on-how-we-used-our-time-in-2022",
    component: _2705eb3a,
    name: "another-year-gone-reflecting-on-how-we-used-our-time-in-2022___au"
  }, {
    path: "/blog/posts/appointing-a-legal-guardian-for-your-children",
    component: _2705eb3a,
    name: "appointing-a-legal-guardian-for-your-children___au"
  }, {
    path: "/blog/posts/are-online-wills-legal",
    component: _2705eb3a,
    name: "are-online-wills-legal___au"
  }, {
    path: "/blog/posts/are-virtual-memorials-really-a-thing",
    component: _2705eb3a,
    name: "are-virtual-memorials-really-a-thing___au"
  }, {
    path: "/blog/posts/australian-funeral-costs-are-on-the-rise-and-heres-what-to-do-about-it",
    component: _2705eb3a,
    name: "australian-funeral-costs-are-on-the-rise-and-heres-what-to-do-about-it___au"
  }, {
    path: "/blog/posts/avoid-these-5-death-faux-pas-when-supporting-a-grieving-friend",
    component: _2705eb3a,
    name: "avoid-these-5-death-faux-pas-when-supporting-a-grieving-friend___au"
  }, {
    path: "/blog/posts/avoid-these-top-10-probate-myths",
    component: _2705eb3a,
    name: "avoid-these-top-10-probate-myths___au"
  }, {
    path: "/blog/posts/avoiding-inheritance-disputes-how-to-distribute-assets",
    component: _2705eb3a,
    name: "avoiding-inheritance-disputes-how-to-distribute-assets___au"
  }, {
    path: "/blog/posts/becoming-widowed",
    component: _2705eb3a,
    name: "becoming-widowed___au"
  }, {
    path: "/blog/posts/benefits--a-digital-will",
    component: _2705eb3a,
    name: "benefits--a-digital-will___au"
  }, {
    path: "/blog/posts/can-i-pass-on-family-heirlooms-in-an-online-will-a-guide-for-australians",
    component: _2705eb3a,
    name: "can-i-pass-on-family-heirlooms-in-an-online-will-a-guide-for-australians___au"
  }, {
    path: "/blog/posts/can-we-have-a-tough-conversation",
    component: _2705eb3a,
    name: "can-we-have-a-tough-conversation___au"
  }, {
    path: "/blog/posts/can-you-contest-a-will-after-probate",
    component: _2705eb3a,
    name: "can-you-contest-a-will-after-probate___au"
  }, {
    path: "/blog/posts/charitable-gifts-in-wills",
    component: _2705eb3a,
    name: "charitable-gifts-in-wills___au"
  }, {
    path: "/blog/posts/checklist-for-writing-your-will",
    component: _2705eb3a,
    name: "checklist-for-writing-your-will___au"
  }, {
    path: "/blog/posts/choosing-an-executor-for-your-will-navigating-the-sensitive-topic-with-family",
    component: _2705eb3a,
    name: "choosing-an-executor-for-your-will-navigating-the-sensitive-topic-with-family___au"
  }, {
    path: "/blog/posts/choosing-between-a-professional-or-personal-executor-of-will",
    component: _2705eb3a,
    name: "choosing-between-a-professional-or-personal-executor-of-will___au"
  }, {
    path: "/blog/posts/common-excuses-for-putting-off-writing-your-will-why-you-shouldnt",
    component: _2705eb3a,
    name: "common-excuses-for-putting-off-writing-your-will-why-you-shouldnt___au"
  }, {
    path: "/blog/posts/compassionate-leave-in-australia",
    component: _2705eb3a,
    name: "compassionate-leave-in-australia___au"
  }, {
    path: "/blog/posts/complete-checklist-for-when-someone-dies",
    component: _2705eb3a,
    name: "complete-checklist-for-when-someone-dies___au"
  }, {
    path: "/blog/posts/contested-wills-why-when-how-to-deal-if-this-happens",
    component: _2705eb3a,
    name: "contested-wills-why-when-how-to-deal-if-this-happens___au"
  }, {
    path: "/blog/posts/crafting-meaningful-death-and-funeral-notices-a-guide-for-remembering-loved-ones",
    component: _2705eb3a,
    name: "crafting-meaningful-death-and-funeral-notices-a-guide-for-remembering-loved-ones___au"
  }, {
    path: "/blog/posts/creating-a-retirement-plan",
    component: _2705eb3a,
    name: "creating-a-retirement-plan___au"
  }, {
    path: "/blog/posts/creating-a-will-in-australia-guide",
    component: _2705eb3a,
    name: "creating-a-will-in-australia-guide___au"
  }, {
    path: "/blog/posts/death-doulas-the-all-rounder-for-end-of-life-care",
    component: _2705eb3a,
    name: "death-doulas-the-all-rounder-for-end-of-life-care___au"
  }, {
    path: "/blog/posts/debunking-harmful-organ-donation-myths",
    component: _2705eb3a,
    name: "debunking-harmful-organ-donation-myths___au"
  }, {
    path: "/blog/posts/difference-between-diy-will-kit-and-an-online-will",
    component: _2705eb3a,
    name: "difference-between-diy-will-kit-and-an-online-will___au"
  }, {
    path: "/blog/posts/different-types-of-wills-in-australia",
    component: _2705eb3a,
    name: "different-types-of-wills-in-australia___au"
  }, {
    path: "/blog/posts/do-you-need-a-lawyer-to-write-a-will",
    component: _2705eb3a,
    name: "do-you-need-a-lawyer-to-write-a-will___au"
  }, {
    path: "/blog/posts/embalming-in-australia",
    component: _2705eb3a,
    name: "embalming-in-australia___au"
  }, {
    path: "/blog/posts/end-of-life-planning",
    component: _2705eb3a,
    name: "end-of-life-planning___au"
  }, {
    path: "/blog/posts/essential-guide-to-writing-a-will-estate-planning-for-young-australians-safewill",
    component: _2705eb3a,
    name: "essential-guide-to-writing-a-will-estate-planning-for-young-australians-safewill___au"
  }, {
    path: "/blog/posts/estate-administration",
    component: _2705eb3a,
    name: "estate-administration___au"
  }, {
    path: "/blog/posts/estate-planning-5-things-people-forget",
    component: _2705eb3a,
    name: "estate-planning-5-things-people-forget___au"
  }, {
    path: "/blog/posts/estate-planning-an-important-act-of-love",
    component: _2705eb3a,
    name: "estate-planning-an-important-act-of-love___au"
  }, {
    path: "/blog/posts/estate-planning-in-australia",
    component: _2705eb3a,
    name: "estate-planning-in-australia___au"
  }, {
    path: "/blog/posts/estate-planning-lawyer",
    component: _2705eb3a,
    name: "estate-planning-lawyer___au"
  }, {
    path: "/blog/posts/everything-you-need-to-know-about-bereavement",
    component: _2705eb3a,
    name: "everything-you-need-to-know-about-bereavement___au"
  }, {
    path: "/blog/posts/everything-you-need-to-know-about-funeral-insurance",
    component: _2705eb3a,
    name: "everything-you-need-to-know-about-funeral-insurance___au"
  }, {
    path: "/blog/posts/everything-you-need-to-know-about-wills",
    component: _2705eb3a,
    name: "everything-you-need-to-know-about-wills___au"
  }, {
    path: "/blog/posts/executor-of-will-duties",
    component: _2705eb3a,
    name: "executor-of-will-duties___au"
  }, {
    path: "/blog/posts/final-resting-places-sydneys-oldest-cemeteries",
    component: _2705eb3a,
    name: "final-resting-places-sydneys-oldest-cemeteries___au"
  }, {
    path: "/blog/posts/financial-power-of-attorney",
    component: _2705eb3a,
    name: "financial-power-of-attorney___au"
  }, {
    path: "/blog/posts/finding-australian-death-funeral-notices-online",
    component: _2705eb3a,
    name: "finding-australian-death-funeral-notices-online___au"
  }, {
    path: "/blog/posts/five-essential-steps-when-creating-a-will",
    component: _2705eb3a,
    name: "five-essential-steps-when-creating-a-will___au"
  }, {
    path: "/blog/posts/funeral-costs-in-australia",
    component: _2705eb3a,
    name: "funeral-costs-in-australia___au"
  }, {
    path: "/blog/posts/funeral-etiquette-the-unspoken-need-to-knows",
    component: _2705eb3a,
    name: "funeral-etiquette-the-unspoken-need-to-knows___au"
  }, {
    path: "/blog/posts/funeral-songs",
    component: _2705eb3a,
    name: "funeral-songs___au"
  }, {
    path: "/blog/posts/grief-support-australia",
    component: _2705eb3a,
    name: "grief-support-australia___au"
  }, {
    path: "/blog/posts/handling-debt-in-wills-what-happens-to-your-liabilities",
    component: _2705eb3a,
    name: "handling-debt-in-wills-what-happens-to-your-liabilities___au"
  }, {
    path: "/blog/posts/how-do-i-choose-a-guardian",
    component: _2705eb3a,
    name: "how-do-i-choose-a-guardian___au"
  }, {
    path: "/blog/posts/how-do-i-know-if-probate-has-been-granted",
    component: _2705eb3a,
    name: "how-do-i-know-if-probate-has-been-granted___au"
  }, {
    path: "/blog/posts/how-do-i-sign-my-will",
    component: _2705eb3a,
    name: "how-do-i-sign-my-will___au"
  }, {
    path: "/blog/posts/how-her-brothers-death-influenced-maryams-work-at-safewill",
    component: _2705eb3a,
    name: "how-her-brothers-death-influenced-maryams-work-at-safewill___au"
  }, {
    path: "/blog/posts/how-intestacy-works-in-australia",
    component: _2705eb3a,
    name: "how-intestacy-works-in-australia___au"
  }, {
    path: "/blog/posts/how-long-does-it-take-to-get-a-grant-of-probate-or-letters-of-administration",
    component: _2705eb3a,
    name: "how-long-does-it-take-to-get-a-grant-of-probate-or-letters-of-administration___au"
  }, {
    path: "/blog/posts/how-many-wills-can-you-have",
    component: _2705eb3a,
    name: "how-many-wills-can-you-have___au"
  }, {
    path: "/blog/posts/how-much-does-a-public-trustee-take-from-the-estate",
    component: _2705eb3a,
    name: "how-much-does-a-public-trustee-take-from-the-estate___au"
  }, {
    path: "/blog/posts/how-much-does-a-will-cost-in-australia",
    component: _2705eb3a,
    name: "how-much-does-a-will-cost-in-australia___au"
  }, {
    path: "/blog/posts/how-power-of-attorney-differs-by-state-victoria-vs-wa",
    component: _2705eb3a,
    name: "how-power-of-attorney-differs-by-state-victoria-vs-wa___au"
  }, {
    path: "/blog/posts/how-property-ownership-affects-your-will",
    component: _2705eb3a,
    name: "how-property-ownership-affects-your-will___au"
  }, {
    path: "/blog/posts/how-technology-is-changing-end-of-life-planning",
    component: _2705eb3a,
    name: "how-technology-is-changing-end-of-life-planning___au"
  }, {
    path: "/blog/posts/how-to-appoint-your-power-of-attorney-in-nsw",
    component: _2705eb3a,
    name: "how-to-appoint-your-power-of-attorney-in-nsw___au"
  }, {
    path: "/blog/posts/how-to-become-an-organ-donor-in-australia",
    component: _2705eb3a,
    name: "how-to-become-an-organ-donor-in-australia___au"
  }, {
    path: "/blog/posts/how-to-build-generational-wealth",
    component: _2705eb3a,
    name: "how-to-build-generational-wealth___au"
  }, {
    path: "/blog/posts/how-to-care-for-your-pet-when-you-die",
    component: _2705eb3a,
    name: "how-to-care-for-your-pet-when-you-die___au"
  }, {
    path: "/blog/posts/how-to-choose-a-coffin",
    component: _2705eb3a,
    name: "how-to-choose-a-coffin___au"
  }, {
    path: "/blog/posts/how-to-choose-the-right-funeral-director-a-comprehensive-guide",
    component: _2705eb3a,
    name: "how-to-choose-the-right-funeral-director-a-comprehensive-guide___au"
  }, {
    path: "/blog/posts/how-to-choose-the-right-funeral-flowers",
    component: _2705eb3a,
    name: "how-to-choose-the-right-funeral-flowers___au"
  }, {
    path: "/blog/posts/how-to-choose-your-beneficiaries",
    component: _2705eb3a,
    name: "how-to-choose-your-beneficiaries___au"
  }, {
    path: "/blog/posts/how-to-cope-when-facing-death",
    component: _2705eb3a,
    name: "how-to-cope-when-facing-death___au"
  }, {
    path: "/blog/posts/how-to-create-a-comprehensive-estate-plan-with-corporate-structures-and-wills",
    component: _2705eb3a,
    name: "how-to-create-a-comprehensive-estate-plan-with-corporate-structures-and-wills___au"
  }, {
    path: "/blog/posts/how-to-decide-between-open-or-closed-casket-funeral",
    component: _2705eb3a,
    name: "how-to-decide-between-open-or-closed-casket-funeral___au"
  }, {
    path: "/blog/posts/how-to-decline-an-inheritance-in-australia-a-guide-to-disclaiming-your-inheritance",
    component: _2705eb3a,
    name: "how-to-decline-an-inheritance-in-australia-a-guide-to-disclaiming-your-inheritance___au"
  }, {
    path: "/blog/posts/how-to-easily-include-a-charity-in-your-will",
    component: _2705eb3a,
    name: "how-to-easily-include-a-charity-in-your-will___au"
  }, {
    path: "/blog/posts/how-to-find-a-will",
    component: _2705eb3a,
    name: "how-to-find-a-will___au"
  }, {
    path: "/blog/posts/how-to-get-a-death-certificate",
    component: _2705eb3a,
    name: "how-to-get-a-death-certificate___au"
  }, {
    path: "/blog/posts/how-to-get-a-living-will",
    component: _2705eb3a,
    name: "how-to-get-a-living-will___au"
  }, {
    path: "/blog/posts/how-to-include-cryptocurrency-in-your-will",
    component: _2705eb3a,
    name: "how-to-include-cryptocurrency-in-your-will___au"
  }, {
    path: "/blog/posts/how-to-make-your-bequest-count-choosing-a-charity",
    component: _2705eb3a,
    name: "how-to-make-your-bequest-count-choosing-a-charity___au"
  }, {
    path: "/blog/posts/how-to-memorialise-your-loved-ones",
    component: _2705eb3a,
    name: "how-to-memorialise-your-loved-ones___au"
  }, {
    path: "/blog/posts/how-to-plan-a-funeral",
    component: _2705eb3a,
    name: "how-to-plan-a-funeral___au"
  }, {
    path: "/blog/posts/how-to-plan-an-internment-of-ashes-ceremony",
    component: _2705eb3a,
    name: "how-to-plan-an-internment-of-ashes-ceremony___au"
  }, {
    path: "/blog/posts/how-to-plan-your-estate-with-foreign-assets",
    component: _2705eb3a,
    name: "how-to-plan-your-estate-with-foreign-assets___au"
  }, {
    path: "/blog/posts/how-to-redirect-mail-through-australia-post",
    component: _2705eb3a,
    name: "how-to-redirect-mail-through-australia-post___au"
  }, {
    path: "/blog/posts/how-to-set-up-a-discretionary-trust",
    component: _2705eb3a,
    name: "how-to-set-up-a-discretionary-trust___au"
  }, {
    path: "/blog/posts/how-to-set-up-a-prepaid-funeral-australia",
    component: _2705eb3a,
    name: "how-to-set-up-a-prepaid-funeral-australia___au"
  }, {
    path: "/blog/posts/how-to-set-up-a-trust-fund",
    component: _2705eb3a,
    name: "how-to-set-up-a-trust-fund___au"
  }, {
    path: "/blog/posts/how-to-support-someone-who-is-dying",
    component: _2705eb3a,
    name: "how-to-support-someone-who-is-dying___au"
  }, {
    path: "/blog/posts/how-to-talk-about-a-loved-ones-death",
    component: _2705eb3a,
    name: "how-to-talk-about-a-loved-ones-death___au"
  }, {
    path: "/blog/posts/how-to-write-a-condolence-message",
    component: _2705eb3a,
    name: "how-to-write-a-condolence-message___au"
  }, {
    path: "/blog/posts/how-to-write-a-eulogy",
    component: _2705eb3a,
    name: "how-to-write-a-eulogy___au"
  }, {
    path: "/blog/posts/how-to-write-a-will-for-your-blended-family",
    component: _2705eb3a,
    name: "how-to-write-a-will-for-your-blended-family___au"
  }, {
    path: "/blog/posts/how-to-write-an-obituary",
    component: _2705eb3a,
    name: "how-to-write-an-obituary___au"
  }, {
    path: "/blog/posts/how-when-to-talk-about-death",
    component: _2705eb3a,
    name: "how-when-to-talk-about-death___au"
  }, {
    path: "/blog/posts/how-you-could-benefit-from-a-family-trust",
    component: _2705eb3a,
    name: "how-you-could-benefit-from-a-family-trust___au"
  }, {
    path: "/blog/posts/industry-update-online-wills-in-the-law",
    component: _2705eb3a,
    name: "industry-update-online-wills-in-the-law___au"
  }, {
    path: "/blog/posts/informal-wills",
    component: _2705eb3a,
    name: "informal-wills___au"
  }, {
    path: "/blog/posts/inheritance-tax-australia",
    component: _2705eb3a,
    name: "inheritance-tax-australia___au"
  }, {
    path: "/blog/posts/is-it-possible-to-contest-a-will",
    component: _2705eb3a,
    name: "is-it-possible-to-contest-a-will___au"
  }, {
    path: "/blog/posts/is-safewill-legit",
    component: _2705eb3a,
    name: "is-safewill-legit___au"
  }, {
    path: "/blog/posts/last-will-testament-what-it-is-why-its-important",
    component: _2705eb3a,
    name: "last-will-testament-what-it-is-why-its-important___au"
  }, {
    path: "/blog/posts/learn-from-these-top-5-deathbed-regrets",
    component: _2705eb3a,
    name: "learn-from-these-top-5-deathbed-regrets___au"
  }, {
    path: "/blog/posts/letters-of-administration",
    component: _2705eb3a,
    name: "letters-of-administration___au"
  }, {
    path: "/blog/posts/letters-of-administration-nsw",
    component: _2705eb3a,
    name: "letters-of-administration-nsw___au"
  }, {
    path: "/blog/posts/listen-to-these-5-podcasts-if-your-grieving",
    component: _2705eb3a,
    name: "listen-to-these-5-podcasts-if-your-grieving___au"
  }, {
    path: "/blog/posts/maryams-son-was-stillborn-heres-her-advice-to-support-grieving-people",
    component: _2705eb3a,
    name: "maryams-son-was-stillborn-heres-her-advice-to-support-grieving-people___au"
  }, {
    path: "/blog/posts/meaningful-memorials-ideas-for-celebrating-a-life-well-lived",
    component: _2705eb3a,
    name: "meaningful-memorials-ideas-for-celebrating-a-life-well-lived___au"
  }, {
    path: "/blog/posts/medical-power-of-attorney",
    component: _2705eb3a,
    name: "medical-power-of-attorney___au"
  }, {
    path: "/blog/posts/memento-mori",
    component: _2705eb3a,
    name: "memento-mori___au"
  }, {
    path: "/blog/posts/millennials-am-i-too-young-to-write-a-will",
    component: _2705eb3a,
    name: "millennials-am-i-too-young-to-write-a-will___au"
  }, {
    path: "/blog/posts/palliative-care-and-end-of-life-care",
    component: _2705eb3a,
    name: "palliative-care-and-end-of-life-care___au"
  }, {
    path: "/blog/posts/planning-a-celebration-of-life",
    component: _2705eb3a,
    name: "planning-a-celebration-of-life___au"
  }, {
    path: "/blog/posts/poems-for-funerals",
    component: _2705eb3a,
    name: "poems-for-funerals___au"
  }, {
    path: "/blog/posts/power-of-attorney-in-queensland",
    component: _2705eb3a,
    name: "power-of-attorney-in-queensland___au"
  }, {
    path: "/blog/posts/prenup-in-australia-everything-you-need-to-know-in-2023",
    component: _2705eb3a,
    name: "prenup-in-australia-everything-you-need-to-know-in-2023___au"
  }, {
    path: "/blog/posts/probate-in-nsw",
    component: _2705eb3a,
    name: "probate-in-nsw___au"
  }, {
    path: "/blog/posts/probate-queensland",
    component: _2705eb3a,
    name: "probate-queensland___au"
  }, {
    path: "/blog/posts/probate-victoria",
    component: _2705eb3a,
    name: "probate-victoria___au"
  }, {
    path: "/blog/posts/probate-what-is-it-and-how-does-the-process-work",
    component: _2705eb3a,
    name: "probate-what-is-it-and-how-does-the-process-work___au"
  }, {
    path: "/blog/posts/public-trustees-in-australia",
    component: _2705eb3a,
    name: "public-trustees-in-australia___au"
  }, {
    path: "/blog/posts/public-vs-private-trusts-whats-the-difference",
    component: _2705eb3a,
    name: "public-vs-private-trusts-whats-the-difference___au"
  }, {
    path: "/blog/posts/required-info-for-an-online-will",
    component: _2705eb3a,
    name: "required-info-for-an-online-will___au"
  }, {
    path: "/blog/posts/resealing-probate",
    component: _2705eb3a,
    name: "resealing-probate___au"
  }, {
    path: "/blog/posts/scattering-ashes",
    component: _2705eb3a,
    name: "scattering-ashes___au"
  }, {
    path: "/blog/posts/should-i-witness-a-will",
    component: _2705eb3a,
    name: "should-i-witness-a-will___au"
  }, {
    path: "/blog/posts/simplifying-deceased-estate-property-transfers-with-pexa",
    component: _2705eb3a,
    name: "simplifying-deceased-estate-property-transfers-with-pexa___au"
  }, {
    path: "/blog/posts/spousal-inheritance-rights-in-australia",
    component: _2705eb3a,
    name: "spousal-inheritance-rights-in-australia___au"
  }, {
    path: "/blog/posts/supporting-your-work-bestie-through-grief",
    component: _2705eb3a,
    name: "supporting-your-work-bestie-through-grief___au"
  }, {
    path: "/blog/posts/testamentary-capacity",
    component: _2705eb3a,
    name: "testamentary-capacity___au"
  }, {
    path: "/blog/posts/the-5-most-common-mistakes-people-make-when-writing-their-will",
    component: _2705eb3a,
    name: "the-5-most-common-mistakes-people-make-when-writing-their-will___au"
  }, {
    path: "/blog/posts/the-consequences-of-dying-without-a-will",
    component: _2705eb3a,
    name: "the-consequences-of-dying-without-a-will___au"
  }, {
    path: "/blog/posts/the-cost-of-writing-your-will-with-a-lawyer",
    component: _2705eb3a,
    name: "the-cost-of-writing-your-will-with-a-lawyer___au"
  }, {
    path: "/blog/posts/the-difference-between-estate-and-gifts",
    component: _2705eb3a,
    name: "the-difference-between-estate-and-gifts___au"
  }, {
    path: "/blog/posts/the-facts-and-fictions-youve-probably-heard-about-writing-a-will",
    component: _2705eb3a,
    name: "the-facts-and-fictions-youve-probably-heard-about-writing-a-will___au"
  }, {
    path: "/blog/posts/the-future-of-burial-plots-when-space-solutions-run-out",
    component: _2705eb3a,
    name: "the-future-of-burial-plots-when-space-solutions-run-out___au"
  }, {
    path: "/blog/posts/the-power-of-choosing-your-own-wake",
    component: _2705eb3a,
    name: "the-power-of-choosing-your-own-wake___au"
  }, {
    path: "/blog/posts/the-psychology-of-supporting-ageing-parents",
    component: _2705eb3a,
    name: "the-psychology-of-supporting-ageing-parents___au"
  }, {
    path: "/blog/posts/the-socio-economic-divide-in-estate-planning-which-australians-have-a-will",
    component: _2705eb3a,
    name: "the-socio-economic-divide-in-estate-planning-which-australians-have-a-will___au"
  }, {
    path: "/blog/posts/the-ultimate-guide-to-wills",
    component: _2705eb3a,
    name: "the-ultimate-guide-to-wills___au"
  }, {
    path: "/blog/posts/to-reach-toward-infinity",
    component: _2705eb3a,
    name: "to-reach-toward-infinity___au"
  }, {
    path: "/blog/posts/top-3-census-findings",
    component: _2705eb3a,
    name: "top-3-census-findings___au"
  }, {
    path: "/blog/posts/top-5-myths",
    component: _2705eb3a,
    name: "top-5-myths___au"
  }, {
    path: "/blog/posts/top-tips-of-executor-of-a-will",
    component: _2705eb3a,
    name: "top-tips-of-executor-of-a-will___au"
  }, {
    path: "/blog/posts/understanding-enduring-power-of-attorney-a-comprehensive-guide",
    component: _2705eb3a,
    name: "understanding-enduring-power-of-attorney-a-comprehensive-guide___au"
  }, {
    path: "/blog/posts/understanding-government-assistance-for-bereaved-families-in-australia",
    component: _2705eb3a,
    name: "understanding-government-assistance-for-bereaved-families-in-australia___au"
  }, {
    path: "/blog/posts/updating-wills",
    component: _2705eb3a,
    name: "updating-wills___au"
  }, {
    path: "/blog/posts/updating-your-will-for-protection",
    component: _2705eb3a,
    name: "updating-your-will-for-protection___au"
  }, {
    path: "/blog/posts/urns-for-ashes",
    component: _2705eb3a,
    name: "urns-for-ashes___au"
  }, {
    path: "/blog/posts/using-a-professional-executor",
    component: _2705eb3a,
    name: "using-a-professional-executor___au"
  }, {
    path: "/blog/posts/what-actually-happens-in-grief-bereavement-counselling",
    component: _2705eb3a,
    name: "what-actually-happens-in-grief-bereavement-counselling___au"
  }, {
    path: "/blog/posts/what-age-should-you-start-thinking-about-making-a-will",
    component: _2705eb3a,
    name: "what-age-should-you-start-thinking-about-making-a-will___au"
  }, {
    path: "/blog/posts/what-are-the-5-stages-of-grief",
    component: _2705eb3a,
    name: "what-are-the-5-stages-of-grief___au"
  }, {
    path: "/blog/posts/what-does-a-probate-attorney-actually-do",
    component: _2705eb3a,
    name: "what-does-a-probate-attorney-actually-do___au"
  }, {
    path: "/blog/posts/what-does-an-executor-of-a-will-actually-do",
    component: _2705eb3a,
    name: "what-does-an-executor-of-a-will-actually-do___au"
  }, {
    path: "/blog/posts/what-does-it-mean-if-a-letter-of-administration-is-contested",
    component: _2705eb3a,
    name: "what-does-it-mean-if-a-letter-of-administration-is-contested___au"
  }, {
    path: "/blog/posts/what-does-writing-a-will-have-to-do-with-financial-literacy",
    component: _2705eb3a,
    name: "what-does-writing-a-will-have-to-do-with-financial-literacy___au"
  }, {
    path: "/blog/posts/what-happens-after-letters-of-administration-is-granted",
    component: _2705eb3a,
    name: "what-happens-after-letters-of-administration-is-granted___au"
  }, {
    path: "/blog/posts/what-happens-if-i-die-abroad",
    component: _2705eb3a,
    name: "what-happens-if-i-die-abroad___au"
  }, {
    path: "/blog/posts/what-happens-if-you-cant-afford-aged-care-in-australia",
    component: _2705eb3a,
    name: "what-happens-if-you-cant-afford-aged-care-in-australia___au"
  }, {
    path: "/blog/posts/what-happens-to-bank-accounts-when-someone-dies-in-australia",
    component: _2705eb3a,
    name: "what-happens-to-bank-accounts-when-someone-dies-in-australia___au"
  }, {
    path: "/blog/posts/what-happens-to-debt-when-you-die",
    component: _2705eb3a,
    name: "what-happens-to-debt-when-you-die___au"
  }, {
    path: "/blog/posts/what-happens-to-my-children",
    component: _2705eb3a,
    name: "what-happens-to-my-children___au"
  }, {
    path: "/blog/posts/what-happens-to-my-social-media-when-i-die",
    component: _2705eb3a,
    name: "what-happens-to-my-social-media-when-i-die___au"
  }, {
    path: "/blog/posts/what-happens-to-my-socials-when-i-die",
    component: _2705eb3a,
    name: "what-happens-to-my-socials-when-i-die___au"
  }, {
    path: "/blog/posts/what-happens-to-the-family-home-after-you-die",
    component: _2705eb3a,
    name: "what-happens-to-the-family-home-after-you-die___au"
  }, {
    path: "/blog/posts/what-happens-to-your-pet-when-you-die",
    component: _2705eb3a,
    name: "what-happens-to-your-pet-when-you-die___au"
  }, {
    path: "/blog/posts/what-happens-to-your-property-when-you-pass-away",
    component: _2705eb3a,
    name: "what-happens-to-your-property-when-you-pass-away___au"
  }, {
    path: "/blog/posts/what-happens-to-your-superannuation-when-you-die",
    component: _2705eb3a,
    name: "what-happens-to-your-superannuation-when-you-die___au"
  }, {
    path: "/blog/posts/what-happens-when-executors-cant-agree",
    component: _2705eb3a,
    name: "what-happens-when-executors-cant-agree___au"
  }, {
    path: "/blog/posts/what-is-a-codicil-to-a-will",
    component: _2705eb3a,
    name: "what-is-a-codicil-to-a-will___au"
  }, {
    path: "/blog/posts/what-is-a-crematorium",
    component: _2705eb3a,
    name: "what-is-a-crematorium___au"
  }, {
    path: "/blog/posts/what-is-a-personal-legacy",
    component: _2705eb3a,
    name: "what-is-a-personal-legacy___au"
  }, {
    path: "/blog/posts/what-is-a-power-of-attorney",
    component: _2705eb3a,
    name: "what-is-a-power-of-attorney___au"
  }, {
    path: "/blog/posts/what-is-a-testamentary-trust",
    component: _2705eb3a,
    name: "what-is-a-testamentary-trust___au"
  }, {
    path: "/blog/posts/what-is-a-traditional-funeral",
    component: _2705eb3a,
    name: "what-is-a-traditional-funeral___au"
  }, {
    path: "/blog/posts/what-is-a-trust",
    component: _2705eb3a,
    name: "what-is-a-trust___au"
  }, {
    path: "/blog/posts/what-is-a-will-and-why-you-should-have-one",
    component: _2705eb3a,
    name: "what-is-a-will-and-why-you-should-have-one___au"
  }, {
    path: "/blog/posts/what-is-an-enduring-guardianship",
    component: _2705eb3a,
    name: "what-is-an-enduring-guardianship___au"
  }, {
    path: "/blog/posts/what-is-an-executor-and-how-do-you-choose-one",
    component: _2705eb3a,
    name: "what-is-an-executor-and-how-do-you-choose-one___au"
  }, {
    path: "/blog/posts/what-is-codicil-when-could-it-be-useful-for-you",
    component: _2705eb3a,
    name: "what-is-codicil-when-could-it-be-useful-for-you___au"
  }, {
    path: "/blog/posts/what-is-final-expense-life-insurance",
    component: _2705eb3a,
    name: "what-is-final-expense-life-insurance___au"
  }, {
    path: "/blog/posts/what-is-probate",
    component: _2705eb3a,
    name: "what-is-probate___au"
  }, {
    path: "/blog/posts/what-is-the-effect-of-marriage-and-divorce-on-your-will",
    component: _2705eb3a,
    name: "what-is-the-effect-of-marriage-and-divorce-on-your-will___au"
  }, {
    path: "/blog/posts/what-is-the-family-provisions-act-and-how-often-is-it-used-to-change-a-will",
    component: _2705eb3a,
    name: "what-is-the-family-provisions-act-and-how-often-is-it-used-to-change-a-will___au"
  }, {
    path: "/blog/posts/what-is-undue-influence-on-a-will-maker-how-to-protect-your-loved-ones",
    component: _2705eb3a,
    name: "what-is-undue-influence-on-a-will-maker-how-to-protect-your-loved-ones___au"
  }, {
    path: "/blog/posts/what-rights-do-beneficiaries-of-a-will-have",
    component: _2705eb3a,
    name: "what-rights-do-beneficiaries-of-a-will-have___au"
  }, {
    path: "/blog/posts/what-to-do-when-someone-dies",
    component: _2705eb3a,
    name: "what-to-do-when-someone-dies___au"
  }, {
    path: "/blog/posts/what-to-do-when-someone-dies-at-home",
    component: _2705eb3a,
    name: "what-to-do-when-someone-dies-at-home___au"
  }, {
    path: "/blog/posts/what-to-say-to-someone-in-grief-instead-of-sorry-for-your-loss",
    component: _2705eb3a,
    name: "what-to-say-to-someone-in-grief-instead-of-sorry-for-your-loss___au"
  }, {
    path: "/blog/posts/what-to-say-when-someone-dies",
    component: _2705eb3a,
    name: "what-to-say-when-someone-dies___au"
  }, {
    path: "/blog/posts/what-to-wear-to-a-funeral",
    component: _2705eb3a,
    name: "what-to-wear-to-a-funeral___au"
  }, {
    path: "/blog/posts/what-you-need-to-know-about-inheritance-how-it-works",
    component: _2705eb3a,
    name: "what-you-need-to-know-about-inheritance-how-it-works___au"
  }, {
    path: "/blog/posts/what-you-need-to-know-legal-guardianship-australia",
    component: _2705eb3a,
    name: "what-you-need-to-know-legal-guardianship-australia___au"
  }, {
    path: "/blog/posts/what-you-need-to-write-an-online-will",
    component: _2705eb3a,
    name: "what-you-need-to-write-an-online-will___au"
  }, {
    path: "/blog/posts/whats-the-difference-between-executor-vs-power-of-attorney",
    component: _2705eb3a,
    name: "whats-the-difference-between-executor-vs-power-of-attorney___au"
  }, {
    path: "/blog/posts/whats-the-key-difference-between-a-trust-estate-plan",
    component: _2705eb3a,
    name: "whats-the-key-difference-between-a-trust-estate-plan___au"
  }, {
    path: "/blog/posts/when-is-probate-necessary",
    component: _2705eb3a,
    name: "when-is-probate-necessary___au"
  }, {
    path: "/blog/posts/when-mothers-day-is-hard",
    component: _2705eb3a,
    name: "when-mothers-day-is-hard___au"
  }, {
    path: "/blog/posts/who-is-my-next-of-kin",
    component: _2705eb3a,
    name: "who-is-my-next-of-kin___au"
  }, {
    path: "/blog/posts/why-appoint-a-power-of-attorney",
    component: _2705eb3a,
    name: "why-appoint-a-power-of-attorney___au"
  }, {
    path: "/blog/posts/why-are-death-certificates-important-and-what-can-go-wrong",
    component: _2705eb3a,
    name: "why-are-death-certificates-important-and-what-can-go-wrong___au"
  }, {
    path: "/blog/posts/why-every-parent-needs-a-will",
    component: _2705eb3a,
    name: "why-every-parent-needs-a-will___au"
  }, {
    path: "/blog/posts/why-every-retiree-needs-a-will",
    component: _2705eb3a,
    name: "why-every-retiree-needs-a-will___au"
  }, {
    path: "/blog/posts/why-online-wills-matter-for-the-education-sector",
    component: _2705eb3a,
    name: "why-online-wills-matter-for-the-education-sector___au"
  }, {
    path: "/blog/posts/will-terminology",
    component: _2705eb3a,
    name: "will-terminology___au"
  }, {
    path: "/blog/posts/witnessing-wills-video-technology",
    component: _2705eb3a,
    name: "witnessing-wills-video-technology___au"
  }, {
    path: "/blog/posts/writing-a-death-notice",
    component: _2705eb3a,
    name: "writing-a-death-notice___au"
  }, {
    path: "/blog/posts/your-guide-to-planning-a-memorial-ceremony",
    component: _2705eb3a,
    name: "your-guide-to-planning-a-memorial-ceremony___au"
  }, {
    path: "/nz/blog/guides",
    component: _0178987e,
    name: "blog-guides___nz"
  }, {
    path: "/nz/blog/posts",
    component: _28bc8c82,
    name: "blog-posts___nz"
  }, {
    path: "/nz/charities/directory",
    component: _3a79894e,
    name: "charities-directory___nz"
  }, {
    path: "/nz/blog/posts/10-reasons-why-you-need-a-will",
    component: _2705eb3a,
    name: "10-reasons-why-you-need-a-will___nz"
  }, {
    path: "/nz/blog/posts/11-reasons-you-should-choose-safewill",
    component: _2705eb3a,
    name: "11-reasons-you-should-choose-safewill___nz"
  }, {
    path: "/nz/blog/posts/3-ways-to-save-on-funeral-costs",
    component: _2705eb3a,
    name: "3-ways-to-save-on-funeral-costs___nz"
  }, {
    path: "/nz/blog/posts/4-actionable-tips-for-an-eco-friendly-funeral",
    component: _2705eb3a,
    name: "4-actionable-tips-for-an-eco-friendly-funeral___nz"
  }, {
    path: "/nz/blog/posts/4-alternative-condolence-gifts-to-flowers",
    component: _2705eb3a,
    name: "4-alternative-condolence-gifts-to-flowers___nz"
  }, {
    path: "/nz/blog/posts/5-benefits-of-writing-your-will-young",
    component: _2705eb3a,
    name: "5-benefits-of-writing-your-will-young___nz"
  }, {
    path: "/nz/blog/posts/5-common-myths-about-online-wills",
    component: _2705eb3a,
    name: "5-common-myths-about-online-wills___nz"
  }, {
    path: "/nz/blog/posts/5-different-cultural-approaches-to-death",
    component: _2705eb3a,
    name: "5-different-cultural-approaches-to-death___nz"
  }, {
    path: "/nz/blog/posts/5-distinguishing-benefits-of-digital-vs-traditional-wills",
    component: _2705eb3a,
    name: "5-distinguishing-benefits-of-digital-vs-traditional-wills___nz"
  }, {
    path: "/nz/blog/posts/5-life-altering-takeaways-from-the-top-ted-talks-on-death",
    component: _2705eb3a,
    name: "5-life-altering-takeaways-from-the-top-ted-talks-on-death___nz"
  }, {
    path: "/nz/blog/posts/5-meaningful-funeral-quotes-about-death",
    component: _2705eb3a,
    name: "5-meaningful-funeral-quotes-about-death___nz"
  }, {
    path: "/nz/blog/posts/5-reasons-to-update-your-will",
    component: _2705eb3a,
    name: "5-reasons-to-update-your-will___nz"
  }, {
    path: "/nz/blog/posts/5-scientific-rules-for-making-breaking-goals-in-2023",
    component: _2705eb3a,
    name: "5-scientific-rules-for-making-breaking-goals-in-2023___nz"
  }, {
    path: "/nz/blog/posts/5-surprising-celebrities-who-died-without-a-will",
    component: _2705eb3a,
    name: "5-surprising-celebrities-who-died-without-a-will___nz"
  }, {
    path: "/nz/blog/posts/5-tips-to-safeguard-your-mental-health-against-stress",
    component: _2705eb3a,
    name: "5-tips-to-safeguard-your-mental-health-against-stress___nz"
  }, {
    path: "/nz/blog/posts/6-easy-health-hacks-for-a-longer-life",
    component: _2705eb3a,
    name: "6-easy-health-hacks-for-a-longer-life___nz"
  }, {
    path: "/nz/blog/posts/6-ways-to-handle-your-estate",
    component: _2705eb3a,
    name: "6-ways-to-handle-your-estate___nz"
  }, {
    path: "/nz/blog/posts/a-guide-to-sydneys-cemeteries-in-2022",
    component: _2705eb3a,
    name: "a-guide-to-sydneys-cemeteries-in-2022___nz"
  }, {
    path: "/nz/blog/posts/advance-care-directive",
    component: _2705eb3a,
    name: "advance-care-directive___nz"
  }, {
    path: "/nz/blog/posts/advanced-healthcare-directives-matter-heres-why",
    component: _2705eb3a,
    name: "advanced-healthcare-directives-matter-heres-why___nz"
  }, {
    path: "/nz/blog/posts/another-year-gone-reflecting-on-how-we-used-our-time-in-2022",
    component: _2705eb3a,
    name: "another-year-gone-reflecting-on-how-we-used-our-time-in-2022___nz"
  }, {
    path: "/nz/blog/posts/appointing-a-legal-guardian-for-your-children",
    component: _2705eb3a,
    name: "appointing-a-legal-guardian-for-your-children___nz"
  }, {
    path: "/nz/blog/posts/are-online-wills-legal",
    component: _2705eb3a,
    name: "are-online-wills-legal___nz"
  }, {
    path: "/nz/blog/posts/are-virtual-memorials-really-a-thing",
    component: _2705eb3a,
    name: "are-virtual-memorials-really-a-thing___nz"
  }, {
    path: "/nz/blog/posts/australian-funeral-costs-are-on-the-rise-and-heres-what-to-do-about-it",
    component: _2705eb3a,
    name: "australian-funeral-costs-are-on-the-rise-and-heres-what-to-do-about-it___nz"
  }, {
    path: "/nz/blog/posts/avoid-these-5-death-faux-pas-when-supporting-a-grieving-friend",
    component: _2705eb3a,
    name: "avoid-these-5-death-faux-pas-when-supporting-a-grieving-friend___nz"
  }, {
    path: "/nz/blog/posts/avoid-these-top-10-probate-myths",
    component: _2705eb3a,
    name: "avoid-these-top-10-probate-myths___nz"
  }, {
    path: "/nz/blog/posts/avoiding-inheritance-disputes-how-to-distribute-assets",
    component: _2705eb3a,
    name: "avoiding-inheritance-disputes-how-to-distribute-assets___nz"
  }, {
    path: "/nz/blog/posts/becoming-widowed",
    component: _2705eb3a,
    name: "becoming-widowed___nz"
  }, {
    path: "/nz/blog/posts/benefits--a-digital-will",
    component: _2705eb3a,
    name: "benefits--a-digital-will___nz"
  }, {
    path: "/nz/blog/posts/can-i-pass-on-family-heirlooms-in-an-online-will-a-guide-for-australians",
    component: _2705eb3a,
    name: "can-i-pass-on-family-heirlooms-in-an-online-will-a-guide-for-australians___nz"
  }, {
    path: "/nz/blog/posts/can-we-have-a-tough-conversation",
    component: _2705eb3a,
    name: "can-we-have-a-tough-conversation___nz"
  }, {
    path: "/nz/blog/posts/can-you-contest-a-will-after-probate",
    component: _2705eb3a,
    name: "can-you-contest-a-will-after-probate___nz"
  }, {
    path: "/nz/blog/posts/charitable-gifts-in-wills",
    component: _2705eb3a,
    name: "charitable-gifts-in-wills___nz"
  }, {
    path: "/nz/blog/posts/checklist-for-writing-your-will",
    component: _2705eb3a,
    name: "checklist-for-writing-your-will___nz"
  }, {
    path: "/nz/blog/posts/choosing-an-executor-for-your-will-navigating-the-sensitive-topic-with-family",
    component: _2705eb3a,
    name: "choosing-an-executor-for-your-will-navigating-the-sensitive-topic-with-family___nz"
  }, {
    path: "/nz/blog/posts/choosing-between-a-professional-or-personal-executor-of-will",
    component: _2705eb3a,
    name: "choosing-between-a-professional-or-personal-executor-of-will___nz"
  }, {
    path: "/nz/blog/posts/common-excuses-for-putting-off-writing-your-will-why-you-shouldnt",
    component: _2705eb3a,
    name: "common-excuses-for-putting-off-writing-your-will-why-you-shouldnt___nz"
  }, {
    path: "/nz/blog/posts/compassionate-leave-in-australia",
    component: _2705eb3a,
    name: "compassionate-leave-in-australia___nz"
  }, {
    path: "/nz/blog/posts/complete-checklist-for-when-someone-dies",
    component: _2705eb3a,
    name: "complete-checklist-for-when-someone-dies___nz"
  }, {
    path: "/nz/blog/posts/contested-wills-why-when-how-to-deal-if-this-happens",
    component: _2705eb3a,
    name: "contested-wills-why-when-how-to-deal-if-this-happens___nz"
  }, {
    path: "/nz/blog/posts/crafting-meaningful-death-and-funeral-notices-a-guide-for-remembering-loved-ones",
    component: _2705eb3a,
    name: "crafting-meaningful-death-and-funeral-notices-a-guide-for-remembering-loved-ones___nz"
  }, {
    path: "/nz/blog/posts/creating-a-retirement-plan",
    component: _2705eb3a,
    name: "creating-a-retirement-plan___nz"
  }, {
    path: "/nz/blog/posts/creating-a-will-in-australia-guide",
    component: _2705eb3a,
    name: "creating-a-will-in-australia-guide___nz"
  }, {
    path: "/nz/blog/posts/death-doulas-the-all-rounder-for-end-of-life-care",
    component: _2705eb3a,
    name: "death-doulas-the-all-rounder-for-end-of-life-care___nz"
  }, {
    path: "/nz/blog/posts/debunking-harmful-organ-donation-myths",
    component: _2705eb3a,
    name: "debunking-harmful-organ-donation-myths___nz"
  }, {
    path: "/nz/blog/posts/difference-between-diy-will-kit-and-an-online-will",
    component: _2705eb3a,
    name: "difference-between-diy-will-kit-and-an-online-will___nz"
  }, {
    path: "/nz/blog/posts/different-types-of-wills-in-australia",
    component: _2705eb3a,
    name: "different-types-of-wills-in-australia___nz"
  }, {
    path: "/nz/blog/posts/do-you-need-a-lawyer-to-write-a-will",
    component: _2705eb3a,
    name: "do-you-need-a-lawyer-to-write-a-will___nz"
  }, {
    path: "/nz/blog/posts/embalming-in-australia",
    component: _2705eb3a,
    name: "embalming-in-australia___nz"
  }, {
    path: "/nz/blog/posts/end-of-life-planning",
    component: _2705eb3a,
    name: "end-of-life-planning___nz"
  }, {
    path: "/nz/blog/posts/essential-guide-to-writing-a-will-estate-planning-for-young-australians-safewill",
    component: _2705eb3a,
    name: "essential-guide-to-writing-a-will-estate-planning-for-young-australians-safewill___nz"
  }, {
    path: "/nz/blog/posts/estate-administration",
    component: _2705eb3a,
    name: "estate-administration___nz"
  }, {
    path: "/nz/blog/posts/estate-planning-5-things-people-forget",
    component: _2705eb3a,
    name: "estate-planning-5-things-people-forget___nz"
  }, {
    path: "/nz/blog/posts/estate-planning-an-important-act-of-love",
    component: _2705eb3a,
    name: "estate-planning-an-important-act-of-love___nz"
  }, {
    path: "/nz/blog/posts/estate-planning-in-australia",
    component: _2705eb3a,
    name: "estate-planning-in-australia___nz"
  }, {
    path: "/nz/blog/posts/estate-planning-lawyer",
    component: _2705eb3a,
    name: "estate-planning-lawyer___nz"
  }, {
    path: "/nz/blog/posts/everything-you-need-to-know-about-bereavement",
    component: _2705eb3a,
    name: "everything-you-need-to-know-about-bereavement___nz"
  }, {
    path: "/nz/blog/posts/everything-you-need-to-know-about-funeral-insurance",
    component: _2705eb3a,
    name: "everything-you-need-to-know-about-funeral-insurance___nz"
  }, {
    path: "/nz/blog/posts/everything-you-need-to-know-about-wills",
    component: _2705eb3a,
    name: "everything-you-need-to-know-about-wills___nz"
  }, {
    path: "/nz/blog/posts/executor-of-will-duties",
    component: _2705eb3a,
    name: "executor-of-will-duties___nz"
  }, {
    path: "/nz/blog/posts/final-resting-places-sydneys-oldest-cemeteries",
    component: _2705eb3a,
    name: "final-resting-places-sydneys-oldest-cemeteries___nz"
  }, {
    path: "/nz/blog/posts/financial-power-of-attorney",
    component: _2705eb3a,
    name: "financial-power-of-attorney___nz"
  }, {
    path: "/nz/blog/posts/finding-australian-death-funeral-notices-online",
    component: _2705eb3a,
    name: "finding-australian-death-funeral-notices-online___nz"
  }, {
    path: "/nz/blog/posts/five-essential-steps-when-creating-a-will",
    component: _2705eb3a,
    name: "five-essential-steps-when-creating-a-will___nz"
  }, {
    path: "/nz/blog/posts/funeral-costs-in-australia",
    component: _2705eb3a,
    name: "funeral-costs-in-australia___nz"
  }, {
    path: "/nz/blog/posts/funeral-etiquette-the-unspoken-need-to-knows",
    component: _2705eb3a,
    name: "funeral-etiquette-the-unspoken-need-to-knows___nz"
  }, {
    path: "/nz/blog/posts/funeral-songs",
    component: _2705eb3a,
    name: "funeral-songs___nz"
  }, {
    path: "/nz/blog/posts/grief-support-australia",
    component: _2705eb3a,
    name: "grief-support-australia___nz"
  }, {
    path: "/nz/blog/posts/handling-debt-in-wills-what-happens-to-your-liabilities",
    component: _2705eb3a,
    name: "handling-debt-in-wills-what-happens-to-your-liabilities___nz"
  }, {
    path: "/nz/blog/posts/how-do-i-choose-a-guardian",
    component: _2705eb3a,
    name: "how-do-i-choose-a-guardian___nz"
  }, {
    path: "/nz/blog/posts/how-do-i-know-if-probate-has-been-granted",
    component: _2705eb3a,
    name: "how-do-i-know-if-probate-has-been-granted___nz"
  }, {
    path: "/nz/blog/posts/how-do-i-sign-my-will",
    component: _2705eb3a,
    name: "how-do-i-sign-my-will___nz"
  }, {
    path: "/nz/blog/posts/how-her-brothers-death-influenced-maryams-work-at-safewill",
    component: _2705eb3a,
    name: "how-her-brothers-death-influenced-maryams-work-at-safewill___nz"
  }, {
    path: "/nz/blog/posts/how-intestacy-works-in-australia",
    component: _2705eb3a,
    name: "how-intestacy-works-in-australia___nz"
  }, {
    path: "/nz/blog/posts/how-long-does-it-take-to-get-a-grant-of-probate-or-letters-of-administration",
    component: _2705eb3a,
    name: "how-long-does-it-take-to-get-a-grant-of-probate-or-letters-of-administration___nz"
  }, {
    path: "/nz/blog/posts/how-many-wills-can-you-have",
    component: _2705eb3a,
    name: "how-many-wills-can-you-have___nz"
  }, {
    path: "/nz/blog/posts/how-much-does-a-public-trustee-take-from-the-estate",
    component: _2705eb3a,
    name: "how-much-does-a-public-trustee-take-from-the-estate___nz"
  }, {
    path: "/nz/blog/posts/how-much-does-a-will-cost-in-australia",
    component: _2705eb3a,
    name: "how-much-does-a-will-cost-in-australia___nz"
  }, {
    path: "/nz/blog/posts/how-power-of-attorney-differs-by-state-victoria-vs-wa",
    component: _2705eb3a,
    name: "how-power-of-attorney-differs-by-state-victoria-vs-wa___nz"
  }, {
    path: "/nz/blog/posts/how-property-ownership-affects-your-will",
    component: _2705eb3a,
    name: "how-property-ownership-affects-your-will___nz"
  }, {
    path: "/nz/blog/posts/how-technology-is-changing-end-of-life-planning",
    component: _2705eb3a,
    name: "how-technology-is-changing-end-of-life-planning___nz"
  }, {
    path: "/nz/blog/posts/how-to-appoint-your-power-of-attorney-in-nsw",
    component: _2705eb3a,
    name: "how-to-appoint-your-power-of-attorney-in-nsw___nz"
  }, {
    path: "/nz/blog/posts/how-to-become-an-organ-donor-in-australia",
    component: _2705eb3a,
    name: "how-to-become-an-organ-donor-in-australia___nz"
  }, {
    path: "/nz/blog/posts/how-to-build-generational-wealth",
    component: _2705eb3a,
    name: "how-to-build-generational-wealth___nz"
  }, {
    path: "/nz/blog/posts/how-to-care-for-your-pet-when-you-die",
    component: _2705eb3a,
    name: "how-to-care-for-your-pet-when-you-die___nz"
  }, {
    path: "/nz/blog/posts/how-to-choose-a-coffin",
    component: _2705eb3a,
    name: "how-to-choose-a-coffin___nz"
  }, {
    path: "/nz/blog/posts/how-to-choose-the-right-funeral-director-a-comprehensive-guide",
    component: _2705eb3a,
    name: "how-to-choose-the-right-funeral-director-a-comprehensive-guide___nz"
  }, {
    path: "/nz/blog/posts/how-to-choose-the-right-funeral-flowers",
    component: _2705eb3a,
    name: "how-to-choose-the-right-funeral-flowers___nz"
  }, {
    path: "/nz/blog/posts/how-to-choose-your-beneficiaries",
    component: _2705eb3a,
    name: "how-to-choose-your-beneficiaries___nz"
  }, {
    path: "/nz/blog/posts/how-to-cope-when-facing-death",
    component: _2705eb3a,
    name: "how-to-cope-when-facing-death___nz"
  }, {
    path: "/nz/blog/posts/how-to-create-a-comprehensive-estate-plan-with-corporate-structures-and-wills",
    component: _2705eb3a,
    name: "how-to-create-a-comprehensive-estate-plan-with-corporate-structures-and-wills___nz"
  }, {
    path: "/nz/blog/posts/how-to-decide-between-open-or-closed-casket-funeral",
    component: _2705eb3a,
    name: "how-to-decide-between-open-or-closed-casket-funeral___nz"
  }, {
    path: "/nz/blog/posts/how-to-decline-an-inheritance-in-australia-a-guide-to-disclaiming-your-inheritance",
    component: _2705eb3a,
    name: "how-to-decline-an-inheritance-in-australia-a-guide-to-disclaiming-your-inheritance___nz"
  }, {
    path: "/nz/blog/posts/how-to-easily-include-a-charity-in-your-will",
    component: _2705eb3a,
    name: "how-to-easily-include-a-charity-in-your-will___nz"
  }, {
    path: "/nz/blog/posts/how-to-find-a-will",
    component: _2705eb3a,
    name: "how-to-find-a-will___nz"
  }, {
    path: "/nz/blog/posts/how-to-get-a-death-certificate",
    component: _2705eb3a,
    name: "how-to-get-a-death-certificate___nz"
  }, {
    path: "/nz/blog/posts/how-to-get-a-living-will",
    component: _2705eb3a,
    name: "how-to-get-a-living-will___nz"
  }, {
    path: "/nz/blog/posts/how-to-include-cryptocurrency-in-your-will",
    component: _2705eb3a,
    name: "how-to-include-cryptocurrency-in-your-will___nz"
  }, {
    path: "/nz/blog/posts/how-to-make-your-bequest-count-choosing-a-charity",
    component: _2705eb3a,
    name: "how-to-make-your-bequest-count-choosing-a-charity___nz"
  }, {
    path: "/nz/blog/posts/how-to-memorialise-your-loved-ones",
    component: _2705eb3a,
    name: "how-to-memorialise-your-loved-ones___nz"
  }, {
    path: "/nz/blog/posts/how-to-plan-a-funeral",
    component: _2705eb3a,
    name: "how-to-plan-a-funeral___nz"
  }, {
    path: "/nz/blog/posts/how-to-plan-an-internment-of-ashes-ceremony",
    component: _2705eb3a,
    name: "how-to-plan-an-internment-of-ashes-ceremony___nz"
  }, {
    path: "/nz/blog/posts/how-to-plan-your-estate-with-foreign-assets",
    component: _2705eb3a,
    name: "how-to-plan-your-estate-with-foreign-assets___nz"
  }, {
    path: "/nz/blog/posts/how-to-redirect-mail-through-australia-post",
    component: _2705eb3a,
    name: "how-to-redirect-mail-through-australia-post___nz"
  }, {
    path: "/nz/blog/posts/how-to-set-up-a-discretionary-trust",
    component: _2705eb3a,
    name: "how-to-set-up-a-discretionary-trust___nz"
  }, {
    path: "/nz/blog/posts/how-to-set-up-a-prepaid-funeral-australia",
    component: _2705eb3a,
    name: "how-to-set-up-a-prepaid-funeral-australia___nz"
  }, {
    path: "/nz/blog/posts/how-to-set-up-a-trust-fund",
    component: _2705eb3a,
    name: "how-to-set-up-a-trust-fund___nz"
  }, {
    path: "/nz/blog/posts/how-to-support-someone-who-is-dying",
    component: _2705eb3a,
    name: "how-to-support-someone-who-is-dying___nz"
  }, {
    path: "/nz/blog/posts/how-to-talk-about-a-loved-ones-death",
    component: _2705eb3a,
    name: "how-to-talk-about-a-loved-ones-death___nz"
  }, {
    path: "/nz/blog/posts/how-to-write-a-condolence-message",
    component: _2705eb3a,
    name: "how-to-write-a-condolence-message___nz"
  }, {
    path: "/nz/blog/posts/how-to-write-a-eulogy",
    component: _2705eb3a,
    name: "how-to-write-a-eulogy___nz"
  }, {
    path: "/nz/blog/posts/how-to-write-a-will-for-your-blended-family",
    component: _2705eb3a,
    name: "how-to-write-a-will-for-your-blended-family___nz"
  }, {
    path: "/nz/blog/posts/how-to-write-an-obituary",
    component: _2705eb3a,
    name: "how-to-write-an-obituary___nz"
  }, {
    path: "/nz/blog/posts/how-when-to-talk-about-death",
    component: _2705eb3a,
    name: "how-when-to-talk-about-death___nz"
  }, {
    path: "/nz/blog/posts/how-you-could-benefit-from-a-family-trust",
    component: _2705eb3a,
    name: "how-you-could-benefit-from-a-family-trust___nz"
  }, {
    path: "/nz/blog/posts/industry-update-online-wills-in-the-law",
    component: _2705eb3a,
    name: "industry-update-online-wills-in-the-law___nz"
  }, {
    path: "/nz/blog/posts/informal-wills",
    component: _2705eb3a,
    name: "informal-wills___nz"
  }, {
    path: "/nz/blog/posts/inheritance-tax-australia",
    component: _2705eb3a,
    name: "inheritance-tax-australia___nz"
  }, {
    path: "/nz/blog/posts/is-it-possible-to-contest-a-will",
    component: _2705eb3a,
    name: "is-it-possible-to-contest-a-will___nz"
  }, {
    path: "/nz/blog/posts/is-safewill-legit",
    component: _2705eb3a,
    name: "is-safewill-legit___nz"
  }, {
    path: "/nz/blog/posts/last-will-testament-what-it-is-why-its-important",
    component: _2705eb3a,
    name: "last-will-testament-what-it-is-why-its-important___nz"
  }, {
    path: "/nz/blog/posts/learn-from-these-top-5-deathbed-regrets",
    component: _2705eb3a,
    name: "learn-from-these-top-5-deathbed-regrets___nz"
  }, {
    path: "/nz/blog/posts/letters-of-administration",
    component: _2705eb3a,
    name: "letters-of-administration___nz"
  }, {
    path: "/nz/blog/posts/letters-of-administration-nsw",
    component: _2705eb3a,
    name: "letters-of-administration-nsw___nz"
  }, {
    path: "/nz/blog/posts/listen-to-these-5-podcasts-if-your-grieving",
    component: _2705eb3a,
    name: "listen-to-these-5-podcasts-if-your-grieving___nz"
  }, {
    path: "/nz/blog/posts/maryams-son-was-stillborn-heres-her-advice-to-support-grieving-people",
    component: _2705eb3a,
    name: "maryams-son-was-stillborn-heres-her-advice-to-support-grieving-people___nz"
  }, {
    path: "/nz/blog/posts/meaningful-memorials-ideas-for-celebrating-a-life-well-lived",
    component: _2705eb3a,
    name: "meaningful-memorials-ideas-for-celebrating-a-life-well-lived___nz"
  }, {
    path: "/nz/blog/posts/medical-power-of-attorney",
    component: _2705eb3a,
    name: "medical-power-of-attorney___nz"
  }, {
    path: "/nz/blog/posts/memento-mori",
    component: _2705eb3a,
    name: "memento-mori___nz"
  }, {
    path: "/nz/blog/posts/millennials-am-i-too-young-to-write-a-will",
    component: _2705eb3a,
    name: "millennials-am-i-too-young-to-write-a-will___nz"
  }, {
    path: "/nz/blog/posts/palliative-care-and-end-of-life-care",
    component: _2705eb3a,
    name: "palliative-care-and-end-of-life-care___nz"
  }, {
    path: "/nz/blog/posts/planning-a-celebration-of-life",
    component: _2705eb3a,
    name: "planning-a-celebration-of-life___nz"
  }, {
    path: "/nz/blog/posts/poems-for-funerals",
    component: _2705eb3a,
    name: "poems-for-funerals___nz"
  }, {
    path: "/nz/blog/posts/power-of-attorney-in-queensland",
    component: _2705eb3a,
    name: "power-of-attorney-in-queensland___nz"
  }, {
    path: "/nz/blog/posts/prenup-in-australia-everything-you-need-to-know-in-2023",
    component: _2705eb3a,
    name: "prenup-in-australia-everything-you-need-to-know-in-2023___nz"
  }, {
    path: "/nz/blog/posts/probate-in-nsw",
    component: _2705eb3a,
    name: "probate-in-nsw___nz"
  }, {
    path: "/nz/blog/posts/probate-queensland",
    component: _2705eb3a,
    name: "probate-queensland___nz"
  }, {
    path: "/nz/blog/posts/probate-victoria",
    component: _2705eb3a,
    name: "probate-victoria___nz"
  }, {
    path: "/nz/blog/posts/probate-what-is-it-and-how-does-the-process-work",
    component: _2705eb3a,
    name: "probate-what-is-it-and-how-does-the-process-work___nz"
  }, {
    path: "/nz/blog/posts/public-trustees-in-australia",
    component: _2705eb3a,
    name: "public-trustees-in-australia___nz"
  }, {
    path: "/nz/blog/posts/public-vs-private-trusts-whats-the-difference",
    component: _2705eb3a,
    name: "public-vs-private-trusts-whats-the-difference___nz"
  }, {
    path: "/nz/blog/posts/required-info-for-an-online-will",
    component: _2705eb3a,
    name: "required-info-for-an-online-will___nz"
  }, {
    path: "/nz/blog/posts/resealing-probate",
    component: _2705eb3a,
    name: "resealing-probate___nz"
  }, {
    path: "/nz/blog/posts/scattering-ashes",
    component: _2705eb3a,
    name: "scattering-ashes___nz"
  }, {
    path: "/nz/blog/posts/should-i-witness-a-will",
    component: _2705eb3a,
    name: "should-i-witness-a-will___nz"
  }, {
    path: "/nz/blog/posts/simplifying-deceased-estate-property-transfers-with-pexa",
    component: _2705eb3a,
    name: "simplifying-deceased-estate-property-transfers-with-pexa___nz"
  }, {
    path: "/nz/blog/posts/spousal-inheritance-rights-in-australia",
    component: _2705eb3a,
    name: "spousal-inheritance-rights-in-australia___nz"
  }, {
    path: "/nz/blog/posts/supporting-your-work-bestie-through-grief",
    component: _2705eb3a,
    name: "supporting-your-work-bestie-through-grief___nz"
  }, {
    path: "/nz/blog/posts/testamentary-capacity",
    component: _2705eb3a,
    name: "testamentary-capacity___nz"
  }, {
    path: "/nz/blog/posts/the-5-most-common-mistakes-people-make-when-writing-their-will",
    component: _2705eb3a,
    name: "the-5-most-common-mistakes-people-make-when-writing-their-will___nz"
  }, {
    path: "/nz/blog/posts/the-consequences-of-dying-without-a-will",
    component: _2705eb3a,
    name: "the-consequences-of-dying-without-a-will___nz"
  }, {
    path: "/nz/blog/posts/the-cost-of-writing-your-will-with-a-lawyer",
    component: _2705eb3a,
    name: "the-cost-of-writing-your-will-with-a-lawyer___nz"
  }, {
    path: "/nz/blog/posts/the-difference-between-estate-and-gifts",
    component: _2705eb3a,
    name: "the-difference-between-estate-and-gifts___nz"
  }, {
    path: "/nz/blog/posts/the-facts-and-fictions-youve-probably-heard-about-writing-a-will",
    component: _2705eb3a,
    name: "the-facts-and-fictions-youve-probably-heard-about-writing-a-will___nz"
  }, {
    path: "/nz/blog/posts/the-future-of-burial-plots-when-space-solutions-run-out",
    component: _2705eb3a,
    name: "the-future-of-burial-plots-when-space-solutions-run-out___nz"
  }, {
    path: "/nz/blog/posts/the-power-of-choosing-your-own-wake",
    component: _2705eb3a,
    name: "the-power-of-choosing-your-own-wake___nz"
  }, {
    path: "/nz/blog/posts/the-psychology-of-supporting-ageing-parents",
    component: _2705eb3a,
    name: "the-psychology-of-supporting-ageing-parents___nz"
  }, {
    path: "/nz/blog/posts/the-socio-economic-divide-in-estate-planning-which-australians-have-a-will",
    component: _2705eb3a,
    name: "the-socio-economic-divide-in-estate-planning-which-australians-have-a-will___nz"
  }, {
    path: "/nz/blog/posts/the-ultimate-guide-to-wills",
    component: _2705eb3a,
    name: "the-ultimate-guide-to-wills___nz"
  }, {
    path: "/nz/blog/posts/to-reach-toward-infinity",
    component: _2705eb3a,
    name: "to-reach-toward-infinity___nz"
  }, {
    path: "/nz/blog/posts/top-3-census-findings",
    component: _2705eb3a,
    name: "top-3-census-findings___nz"
  }, {
    path: "/nz/blog/posts/top-5-myths",
    component: _2705eb3a,
    name: "top-5-myths___nz"
  }, {
    path: "/nz/blog/posts/top-tips-of-executor-of-a-will",
    component: _2705eb3a,
    name: "top-tips-of-executor-of-a-will___nz"
  }, {
    path: "/nz/blog/posts/understanding-enduring-power-of-attorney-a-comprehensive-guide",
    component: _2705eb3a,
    name: "understanding-enduring-power-of-attorney-a-comprehensive-guide___nz"
  }, {
    path: "/nz/blog/posts/understanding-government-assistance-for-bereaved-families-in-australia",
    component: _2705eb3a,
    name: "understanding-government-assistance-for-bereaved-families-in-australia___nz"
  }, {
    path: "/nz/blog/posts/updating-wills",
    component: _2705eb3a,
    name: "updating-wills___nz"
  }, {
    path: "/nz/blog/posts/updating-your-will-for-protection",
    component: _2705eb3a,
    name: "updating-your-will-for-protection___nz"
  }, {
    path: "/nz/blog/posts/urns-for-ashes",
    component: _2705eb3a,
    name: "urns-for-ashes___nz"
  }, {
    path: "/nz/blog/posts/using-a-professional-executor",
    component: _2705eb3a,
    name: "using-a-professional-executor___nz"
  }, {
    path: "/nz/blog/posts/what-actually-happens-in-grief-bereavement-counselling",
    component: _2705eb3a,
    name: "what-actually-happens-in-grief-bereavement-counselling___nz"
  }, {
    path: "/nz/blog/posts/what-age-should-you-start-thinking-about-making-a-will",
    component: _2705eb3a,
    name: "what-age-should-you-start-thinking-about-making-a-will___nz"
  }, {
    path: "/nz/blog/posts/what-are-the-5-stages-of-grief",
    component: _2705eb3a,
    name: "what-are-the-5-stages-of-grief___nz"
  }, {
    path: "/nz/blog/posts/what-does-a-probate-attorney-actually-do",
    component: _2705eb3a,
    name: "what-does-a-probate-attorney-actually-do___nz"
  }, {
    path: "/nz/blog/posts/what-does-an-executor-of-a-will-actually-do",
    component: _2705eb3a,
    name: "what-does-an-executor-of-a-will-actually-do___nz"
  }, {
    path: "/nz/blog/posts/what-does-it-mean-if-a-letter-of-administration-is-contested",
    component: _2705eb3a,
    name: "what-does-it-mean-if-a-letter-of-administration-is-contested___nz"
  }, {
    path: "/nz/blog/posts/what-does-writing-a-will-have-to-do-with-financial-literacy",
    component: _2705eb3a,
    name: "what-does-writing-a-will-have-to-do-with-financial-literacy___nz"
  }, {
    path: "/nz/blog/posts/what-happens-after-letters-of-administration-is-granted",
    component: _2705eb3a,
    name: "what-happens-after-letters-of-administration-is-granted___nz"
  }, {
    path: "/nz/blog/posts/what-happens-if-i-die-abroad",
    component: _2705eb3a,
    name: "what-happens-if-i-die-abroad___nz"
  }, {
    path: "/nz/blog/posts/what-happens-if-you-cant-afford-aged-care-in-australia",
    component: _2705eb3a,
    name: "what-happens-if-you-cant-afford-aged-care-in-australia___nz"
  }, {
    path: "/nz/blog/posts/what-happens-to-bank-accounts-when-someone-dies-in-australia",
    component: _2705eb3a,
    name: "what-happens-to-bank-accounts-when-someone-dies-in-australia___nz"
  }, {
    path: "/nz/blog/posts/what-happens-to-debt-when-you-die",
    component: _2705eb3a,
    name: "what-happens-to-debt-when-you-die___nz"
  }, {
    path: "/nz/blog/posts/what-happens-to-my-children",
    component: _2705eb3a,
    name: "what-happens-to-my-children___nz"
  }, {
    path: "/nz/blog/posts/what-happens-to-my-social-media-when-i-die",
    component: _2705eb3a,
    name: "what-happens-to-my-social-media-when-i-die___nz"
  }, {
    path: "/nz/blog/posts/what-happens-to-my-socials-when-i-die",
    component: _2705eb3a,
    name: "what-happens-to-my-socials-when-i-die___nz"
  }, {
    path: "/nz/blog/posts/what-happens-to-the-family-home-after-you-die",
    component: _2705eb3a,
    name: "what-happens-to-the-family-home-after-you-die___nz"
  }, {
    path: "/nz/blog/posts/what-happens-to-your-pet-when-you-die",
    component: _2705eb3a,
    name: "what-happens-to-your-pet-when-you-die___nz"
  }, {
    path: "/nz/blog/posts/what-happens-to-your-property-when-you-pass-away",
    component: _2705eb3a,
    name: "what-happens-to-your-property-when-you-pass-away___nz"
  }, {
    path: "/nz/blog/posts/what-happens-to-your-superannuation-when-you-die",
    component: _2705eb3a,
    name: "what-happens-to-your-superannuation-when-you-die___nz"
  }, {
    path: "/nz/blog/posts/what-happens-when-executors-cant-agree",
    component: _2705eb3a,
    name: "what-happens-when-executors-cant-agree___nz"
  }, {
    path: "/nz/blog/posts/what-is-a-codicil-to-a-will",
    component: _2705eb3a,
    name: "what-is-a-codicil-to-a-will___nz"
  }, {
    path: "/nz/blog/posts/what-is-a-crematorium",
    component: _2705eb3a,
    name: "what-is-a-crematorium___nz"
  }, {
    path: "/nz/blog/posts/what-is-a-personal-legacy",
    component: _2705eb3a,
    name: "what-is-a-personal-legacy___nz"
  }, {
    path: "/nz/blog/posts/what-is-a-power-of-attorney",
    component: _2705eb3a,
    name: "what-is-a-power-of-attorney___nz"
  }, {
    path: "/nz/blog/posts/what-is-a-testamentary-trust",
    component: _2705eb3a,
    name: "what-is-a-testamentary-trust___nz"
  }, {
    path: "/nz/blog/posts/what-is-a-traditional-funeral",
    component: _2705eb3a,
    name: "what-is-a-traditional-funeral___nz"
  }, {
    path: "/nz/blog/posts/what-is-a-trust",
    component: _2705eb3a,
    name: "what-is-a-trust___nz"
  }, {
    path: "/nz/blog/posts/what-is-a-will-and-why-you-should-have-one",
    component: _2705eb3a,
    name: "what-is-a-will-and-why-you-should-have-one___nz"
  }, {
    path: "/nz/blog/posts/what-is-an-enduring-guardianship",
    component: _2705eb3a,
    name: "what-is-an-enduring-guardianship___nz"
  }, {
    path: "/nz/blog/posts/what-is-an-executor-and-how-do-you-choose-one",
    component: _2705eb3a,
    name: "what-is-an-executor-and-how-do-you-choose-one___nz"
  }, {
    path: "/nz/blog/posts/what-is-codicil-when-could-it-be-useful-for-you",
    component: _2705eb3a,
    name: "what-is-codicil-when-could-it-be-useful-for-you___nz"
  }, {
    path: "/nz/blog/posts/what-is-final-expense-life-insurance",
    component: _2705eb3a,
    name: "what-is-final-expense-life-insurance___nz"
  }, {
    path: "/nz/blog/posts/what-is-probate",
    component: _2705eb3a,
    name: "what-is-probate___nz"
  }, {
    path: "/nz/blog/posts/what-is-the-effect-of-marriage-and-divorce-on-your-will",
    component: _2705eb3a,
    name: "what-is-the-effect-of-marriage-and-divorce-on-your-will___nz"
  }, {
    path: "/nz/blog/posts/what-is-the-family-provisions-act-and-how-often-is-it-used-to-change-a-will",
    component: _2705eb3a,
    name: "what-is-the-family-provisions-act-and-how-often-is-it-used-to-change-a-will___nz"
  }, {
    path: "/nz/blog/posts/what-is-undue-influence-on-a-will-maker-how-to-protect-your-loved-ones",
    component: _2705eb3a,
    name: "what-is-undue-influence-on-a-will-maker-how-to-protect-your-loved-ones___nz"
  }, {
    path: "/nz/blog/posts/what-rights-do-beneficiaries-of-a-will-have",
    component: _2705eb3a,
    name: "what-rights-do-beneficiaries-of-a-will-have___nz"
  }, {
    path: "/nz/blog/posts/what-to-do-when-someone-dies",
    component: _2705eb3a,
    name: "what-to-do-when-someone-dies___nz"
  }, {
    path: "/nz/blog/posts/what-to-do-when-someone-dies-at-home",
    component: _2705eb3a,
    name: "what-to-do-when-someone-dies-at-home___nz"
  }, {
    path: "/nz/blog/posts/what-to-say-to-someone-in-grief-instead-of-sorry-for-your-loss",
    component: _2705eb3a,
    name: "what-to-say-to-someone-in-grief-instead-of-sorry-for-your-loss___nz"
  }, {
    path: "/nz/blog/posts/what-to-say-when-someone-dies",
    component: _2705eb3a,
    name: "what-to-say-when-someone-dies___nz"
  }, {
    path: "/nz/blog/posts/what-to-wear-to-a-funeral",
    component: _2705eb3a,
    name: "what-to-wear-to-a-funeral___nz"
  }, {
    path: "/nz/blog/posts/what-you-need-to-know-about-inheritance-how-it-works",
    component: _2705eb3a,
    name: "what-you-need-to-know-about-inheritance-how-it-works___nz"
  }, {
    path: "/nz/blog/posts/what-you-need-to-know-legal-guardianship-australia",
    component: _2705eb3a,
    name: "what-you-need-to-know-legal-guardianship-australia___nz"
  }, {
    path: "/nz/blog/posts/what-you-need-to-write-an-online-will",
    component: _2705eb3a,
    name: "what-you-need-to-write-an-online-will___nz"
  }, {
    path: "/nz/blog/posts/whats-the-difference-between-executor-vs-power-of-attorney",
    component: _2705eb3a,
    name: "whats-the-difference-between-executor-vs-power-of-attorney___nz"
  }, {
    path: "/nz/blog/posts/whats-the-key-difference-between-a-trust-estate-plan",
    component: _2705eb3a,
    name: "whats-the-key-difference-between-a-trust-estate-plan___nz"
  }, {
    path: "/nz/blog/posts/when-is-probate-necessary",
    component: _2705eb3a,
    name: "when-is-probate-necessary___nz"
  }, {
    path: "/nz/blog/posts/when-mothers-day-is-hard",
    component: _2705eb3a,
    name: "when-mothers-day-is-hard___nz"
  }, {
    path: "/nz/blog/posts/who-is-my-next-of-kin",
    component: _2705eb3a,
    name: "who-is-my-next-of-kin___nz"
  }, {
    path: "/nz/blog/posts/why-appoint-a-power-of-attorney",
    component: _2705eb3a,
    name: "why-appoint-a-power-of-attorney___nz"
  }, {
    path: "/nz/blog/posts/why-are-death-certificates-important-and-what-can-go-wrong",
    component: _2705eb3a,
    name: "why-are-death-certificates-important-and-what-can-go-wrong___nz"
  }, {
    path: "/nz/blog/posts/why-every-parent-needs-a-will",
    component: _2705eb3a,
    name: "why-every-parent-needs-a-will___nz"
  }, {
    path: "/nz/blog/posts/why-every-retiree-needs-a-will",
    component: _2705eb3a,
    name: "why-every-retiree-needs-a-will___nz"
  }, {
    path: "/nz/blog/posts/why-online-wills-matter-for-the-education-sector",
    component: _2705eb3a,
    name: "why-online-wills-matter-for-the-education-sector___nz"
  }, {
    path: "/nz/blog/posts/will-terminology",
    component: _2705eb3a,
    name: "will-terminology___nz"
  }, {
    path: "/nz/blog/posts/witnessing-wills-video-technology",
    component: _2705eb3a,
    name: "witnessing-wills-video-technology___nz"
  }, {
    path: "/nz/blog/posts/writing-a-death-notice",
    component: _2705eb3a,
    name: "writing-a-death-notice___nz"
  }, {
    path: "/nz/blog/posts/your-guide-to-planning-a-memorial-ceremony",
    component: _2705eb3a,
    name: "your-guide-to-planning-a-memorial-ceremony___nz"
  }, {
    path: "/",
    component: _6a230349,
    name: "index___au"
  }, {
    path: "/nz/blog/author/:id?",
    component: _164acafa,
    name: "blog-author-id___nz"
  }, {
    path: "/nz/blog/guides/:slug",
    component: _007c1194,
    name: "blog-guides-slug___nz"
  }, {
    path: "/nz/blog/posts/:slug",
    component: _2705eb3a,
    name: "blog-posts-slug___nz"
  }, {
    path: "/blog/author/:id?",
    component: _164acafa,
    name: "blog-author-id___au"
  }, {
    path: "/blog/guides/:slug",
    component: _007c1194,
    name: "blog-guides-slug___au"
  }, {
    path: "/blog/posts/:slug",
    component: _2705eb3a,
    name: "blog-posts-slug___au"
  }, {
    path: "/nz/affiliates/:affiliate?",
    component: _308556ae,
    name: "affiliates-affiliate___nz"
  }, {
    path: "/nz/i/:code",
    component: _39cbb7fe,
    name: "invite___nz"
  }, {
    path: "/nz/invites/:code?",
    component: _39cbb7fe,
    name: "invites-code___nz"
  }, {
    path: "/nz/offers/:offer?",
    component: _5dff56cc,
    name: "offers-offer___nz"
  }, {
    path: "/nz/partners/:partner?",
    component: _1cc376e4,
    name: "partners-partner___nz"
  }, {
    path: "/nz/promotions/:promotion?",
    component: _31473e5a,
    name: "promotions-promotion___nz"
  }, {
    path: "/affiliates/:affiliate?",
    component: _308556ae,
    name: "affiliates-affiliate___au"
  }, {
    path: "/i/:code",
    component: _39cbb7fe,
    name: "invite___au"
  }, {
    path: "/invites/:code?",
    component: _39cbb7fe,
    name: "invites-code___au"
  }, {
    path: "/offers/:offer?",
    component: _5dff56cc,
    name: "offers-offer___au"
  }, {
    path: "/partners/:partner?",
    component: _1cc376e4,
    name: "partners-partner___au"
  }, {
    path: "/promotions/:promotion?",
    component: _31473e5a,
    name: "promotions-promotion___au"
  }, {
    path: "/nz/*",
    component: _0566ac6f,
    name: "catch-all___nz"
  }, {
    path: "/*",
    component: _0566ac6f,
    name: "catch-all___au"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
